/**
 * Flat message keys: use with useLanguage().t('section.key')
 * _navFromEn / _navFromFr: short labels for HeaderMenu (no dots in key)
 */
export const catalog = {
  en: {
    'layout.docSuffix': 'JASSP',
    'nav.langMenuTitle': 'Language',
    'nav.langFr': 'French',
    'nav.langEn': 'English',
    'nav.logout': 'Logout',
    'nav.adminDashboard': 'Admin dashboard',
    'nav.expertises.viewAll': 'View all expertise areas',
    'pages.contact.title': 'Contact',
    'pages.portfolio.title': 'Our Projects',
    'pages.realisations.title': 'Our work',

    'realisations.hero.h1': 'Our work',
    'realisations.hero.leadBefore': 'An agency that works for its clients is good, ',
    'realisations.hero.leadHighlight': 'with its clients',
    'realisations.hero.leadAfter': ' is better',
    'realisations.filter.label': 'Filter by:',
    'realisations.card.genericDescription':
      'Custom digital platform delivered by JASSP SAS for research and innovation.',
    'pages.expertises.title': 'Expertises',
    'pages.quiSommesNous.title': 'Who we are',
    'quiSommesNous.hero.brand': 'JASSP SAS',
    'quiSommesNous.hero.tagline': 'Your technical partner for bespoke digital solutions',
    'quiSommesNous.hero.intro':
      'Since 2008, we turn complex ideas into high-performance digital platforms, especially in research, agri-food, sustainability and traceability.',
    'quiSommesNous.summary':
      'JASSP SAS is a French company specialised in bespoke digital solutions. We design and build web platforms, digital observatories, blockchain traceability systems and SaaS solutions for research and innovation projects, particularly in agri-food, sustainability and the circular economy. With over 16 years of experience and a strong presence in European projects (PRIMA), we support research institutions and businesses in their digital transformation.',
    'quiSommesNous.history.h2': 'Our history',
    'quiSommesNous.history.body':
      'Founded in October 2008 in Champs-sur-Marne (France), JASSP SAS specialises in bespoke digital solutions. With more than 16 years of experience, we support European and Mediterranean research projects (including PRIMA) by providing full technical expertise: web platforms, digital observatories, blockchain solutions, mobile applications and SaaS architectures.',
    'quiSommesNous.expertise.h2': 'Our expertise',
    'quiSommesNous.expertise.lead':
      'We specialise in turning complex scientific and technical requirements into intuitive, high-performance digital tools.',
    'quiSommesNous.expertise.domainsLabel': 'Areas of excellence:',
    'quiSommesNous.expertise.item1': 'Web & SaaS development',
    'quiSommesNous.expertise.item2': 'Digital observatories and data visualisation',
    'quiSommesNous.expertise.item3': 'Blockchain & traceability solutions',
    'quiSommesNous.expertise.item4': 'European research platforms',
    'quiSommesNous.expertise.item5': 'Mobile applications and IoT',
    'quiSommesNous.values.h2': 'Our values',
    'quiSommesNous.values.item1': 'Technical excellence',
    'quiSommesNous.values.item2': 'Innovation',
    'quiSommesNous.values.item3': 'Reliability (long-term projects)',
    'quiSommesNous.values.item4': 'Collaboration with research institutions',
    'quiSommesNous.values.item5': 'Real impact on projects with societal purpose',
    'quiSommesNous.stats.h2': 'Key figures',
    'quiSommesNous.stats.item1': '16 years of experience',
    'quiSommesNous.stats.item2': '3+ major European projects underway (MoreMedDiet, MedAgriCycle, Techoney…)',
    'quiSommesNous.stats.item3': 'Partners in more than 8 Mediterranean countries',
    'quiSommesNous.stats.item4': 'Projects delivered for prestigious universities and research centres',
    'quiSommesNous.mission.h2': 'Our mission',
    'quiSommesNous.mission.body':
      'To be the trusted technical partner that enables research projects and businesses to innovate through robust, scalable digital solutions tailored to their specific needs.',
    'pages.notreHistoire.title': 'Our history',
    'notreHistoire.body.p1':
      'Founded in 2008, JASSP SAS is a French company specialising in bespoke digital solutions for research and innovation.',
    'notreHistoire.body.p2':
      'For more than 16 years, we have put our technical expertise at the service of ambitious projects in agri-food, sustainability, the circular economy, and traceability.',
    'notreHistoire.body.p3':
      'From designing digital observatories (MoreMedDiet) to blockchain platforms (Techoney), and collaborative Living Lab tools (MedAgriCycle), we support researchers and institutions in their digital transformation.',
    'notreHistoire.image.alt': 'JASSP history',
    'pages.pourquoiNousChoisir.title': 'Why choose us',
    'pourquoiNousChoisir.hero.lead':
      'A trusted technology partner for your research and innovation projects',
    'pourquoiNousChoisir.hero.intro':
      'For more than 16 years, JASSP SAS has been designing and building bespoke digital platforms for European and Mediterranean research programmes — observatories, blockchain traceability, digital twins, and collaborative tools.',
    'pourquoiNousChoisir.image.alt': 'The JASSP team',
    'pourquoiNousChoisir.why.h2': 'Why choose JASSP?',
    'pourquoiNousChoisir.why.item1':
      'More than 16 years of expertise on European and PRIMA research projects',
    'pourquoiNousChoisir.why.item2':
      'End-to-end support: strategy, design, development, cloud hosting, and maintenance',
    'pourquoiNousChoisir.why.item3':
      'SaaS, blockchain, IoT, data observatories, and AI integrated with a single partner',
    'pourquoiNousChoisir.why.item4':
      'A human-scale structure — direct contact with experienced technical teams',
    'pourquoiNousChoisir.why.item5':
      'Solutions built around your constraints, timelines, and stakeholders',
    'pages.nousRejoindre.title': 'Join us',
    'nousRejoindre.hero.lead':
      'Build the next generation of digital platforms for research and innovation with JASSP.',
    'nousRejoindre.hero.intro':
      'We are always looking for talented people who share our passion for technology and impact. Join a human-scale team working on meaningful European and Mediterranean research and innovation projects.',
    'nousRejoindre.image.alt': 'The JASSP team',
    'nousRejoindre.why.h2': 'Why join JASSP?',
    'nousRejoindre.why.item1':
      'Work on ambitious European research projects (PRIMA and beyond)',
    'nousRejoindre.why.item2':
      'A human-scale team where your ideas and skills genuinely matter',
    'nousRejoindre.why.item3':
      'Modern technologies — web platforms, blockchain, data observatories, and SaaS',
    'nousRejoindre.why.item4':
      'Flexibility and a healthy balance between autonomy and collaboration',
    'nousRejoindre.why.item5':
      'Continuous learning and real opportunities to grow with the company',
    'pages.partenaires.title': 'Our partners',
    'pages.partenaires.lead':
      'JASSP works with European and Mediterranean research programmes and institutions — discover the organisations we collaborate with.',
    'partenaires.hero.h1': 'Partners',
    'partenaires.intro.summary':
      'We collaborate with research institutions, universities, and centres of excellence across Europe and the Mediterranean to turn scientific projects into concrete digital solutions.',
    'partenaires.intro.h2': 'Prestigious partners across the Mediterranean basin',
    'partenaires.intro.body':
      'For more than 16 years, JASSP SAS has worked hand in hand with renowned universities and research organisations on European projects (notably PRIMA).',
    'partenaires.projects.h2': 'Our partners by project',
    'partenaires.projects.moreMedDiet.title': 'MoreMedDiet Observatory',
    'partenaires.projects.moreMedDiet.item1': 'Universidad de Extremadura (Coordinator – Spain)',
    'partenaires.projects.moreMedDiet.item2': 'University of Parma & University of Florence (Italy)',
    'partenaires.projects.moreMedDiet.item3': 'Damanhour University (Egypt)',
    'partenaires.projects.moreMedDiet.item4': 'Université de Tunis El Manar (Tunisia)',
    'partenaires.projects.moreMedDiet.item5':
      'Paul Bocuse Institute Research Centre & Telecom SudParis (France)',
    'partenaires.projects.moreMedDiet.item6': 'Polytechnic of Leiria (Portugal)',
    'partenaires.projects.medAgriCycle.title': 'MedAgriCycle (Green Urban AgriCycle)',
    'partenaires.projects.medAgriCycle.item1': 'Erciyes University (Coordinator – Turkey)',
    'partenaires.projects.medAgriCycle.item2': 'Middle East Technical University (METU) & TÜBITAK (Turkey)',
    'partenaires.projects.medAgriCycle.item3': 'University of Reims Champagne-Ardenne (France)',
    'partenaires.projects.medAgriCycle.item4': 'National School of Agriculture of Meknès (Morocco)',
    'partenaires.projects.medAgriCycle.item5':
      'National Research Institute of Rural Engineering, Water and Forests (Tunisia)',
    'partenaires.projects.techoney.title': 'Techoney',
    'partenaires.projects.techoney.item1': 'University of Naples Federico II (Italy)',
    'partenaires.projects.techoney.item2': 'INAT Tunisia',
    'partenaires.projects.techoney.item3': 'CITA (Spain)',
    'partenaires.projects.techoney.item4': 'University of Mersin (Turkey)',
    'partenaires.projects.techoney.item5': 'And several stakeholders in the beekeeping sector',
    'partenaires.funding.h2': 'Funding programmes',

    'expertises.hero.h1': 'Expertises',
    'expertises.hero.lead':
      'From digital strategy to maintenance — design, implementation, cloud hosting, data, IoT, and custom platforms for research and innovation projects.',
    'expertises.section.observatories.body':
      'We design and build powerful web observatories and collaborative platforms for European research and innovation programmes. Our solutions connect stakeholders, structure complex datasets, and deliver clear dashboards for decision-making — from living labs to consumer engagement platforms in agri-food and Mediterranean sectors.',
    'expertises.section.blockchain.body':
      'We deliver secure, transparent blockchain systems for supply chain traceability — especially in agri-food and Mediterranean value chains. From producer records to NFT-based proof of origin, our platforms strengthen trust between producers, distributors, and end consumers.',
    'expertises.section.webmobile.body':
      'We develop modern websites, SaaS applications, and mobile tools tailored to demanding technical environments. Full-stack expertise, clean architecture, and maintainable code let your product evolve with your organisation and funding cycles.',
    'expertises.section.cloudServices.title': 'Cloud services',
    'expertises.section.cloudServices.alt': 'Cloud services and infrastructure',
    'expertises.section.cloudServices.body':
      'A full range of cloud solutions for your infrastructure, development, hosting, and data security needs. We improve efficiency, flexibility, and reliability — scalable hosting, managed databases, CI/CD pipelines, and operational monitoring for research and business platforms.',
    'expertises.section.iot.title': 'IoT',
    'expertises.section.iot.alt': 'Internet of Things',
    'expertises.section.iot.body':
      'We connect sensors, devices, and platforms for smart agriculture, living labs, and industrial monitoring. From data ingestion to real-time dashboards and alerts, our IoT solutions integrate with your observatories, twins, and traceability systems.',
    'expertises.section.dataIa.title': 'Data & AI',
    'expertises.section.dataIa.alt': 'Data and artificial intelligence',
    'expertises.section.dataIa.body':
      'AI is at the heart of our processes and solutions. By combining human expertise and artificial intelligence, we deliver platforms designed to optimise your operations, structure your data assets, and personalise user experiences — from analytics pipelines to intelligent observatory dashboards.',
    'expertises.section.digitalTwin.title': 'Digital Twin',
    'expertises.section.digitalTwin.alt': 'Digital twin technology',
    'expertises.section.digitalTwin.body':
      'We build digital twins that mirror physical assets, processes, and living labs in real time. By connecting IoT sensors, simulation models, and collaborative platforms, our twins help research and industry teams monitor performance, test scenarios, and optimise operations — from urban agriculture to industrial value chains.',
    'expertises.section.decisionDashboard.title': 'Decision Support Dashboards & Machine Learning',
    'expertises.section.decisionDashboard.alt': 'Decision support dashboard and machine learning',
    'expertises.section.decisionDashboard.body':
      'We design interactive decision support dashboards powered by machine learning: predictive models, anomaly detection, and smart recommendations turn complex data into clear, actionable insight for managers, researchers, and field teams. Filters, KPIs, maps, alerts, and exports are tailored to your observatories, traceability chains, and project reporting.',
    'expertises.section.dataManagement.title': 'Data management',
    'expertises.section.dataManagement.alt': 'Data management',
    'expertises.section.dataManagement.body':
      'We help you govern, integrate, and secure your data across observatories, research projects, and business platforms. Master data, quality rules, APIs, and reporting pipelines — so your teams work from reliable, consistent information.',
    'expertises.section.crmErp.title': 'CRM & ERP',
    'expertises.section.crmErp.alt': 'CRM and ERP systems',
    'expertises.section.crmErp.body':
      'Modernise and integrate your sales, lead generation, and operations with CRM and ERP solutions tailored to your organisation. Centralise commercial, financial, and production workflows on a unified, scalable platform connected to your existing tools.',
    'expertises.section.ecommerceCms.title': 'E-commerce & CMS',
    'expertises.section.ecommerceCms.alt': 'E-commerce and content management',
    'expertises.section.ecommerceCms.body':
      'Every business deserves an e-commerce or CMS solution built for its specific needs. We design and develop online stores and content platforms that grow with your ambitions — secure payments, catalogue management, and editorial workflows included.',
    'expertises.methodology.h2': 'A pragmatic approach, built with you',
    'expertises.methodology.lead':
      'We combine discovery, iterative delivery, and close collaboration with your teams — whether you are launching an observatory, a traceability chain, or a custom SaaS product. Each phase is aligned with your constraints, timelines, and stakeholders.',
    'expertises.methodology.cta': 'Discuss your project',
    'expertises.linkPortfolio': 'View our projects',
    'expertises.detail.backToAll': 'All expertise areas',
    'expertises.detail.readMore': 'Learn more',
    'expertises.detail.highlightsTitle': 'What we deliver',
    'expertises.detail.otherTitle': 'Our other expertise areas',
    'expertises.tech.label': 'Technology stack',
    'expertises.tech.digitalTwin.k1': 'IoT',
    'expertises.tech.digitalTwin.k2': 'Simulation',
    'expertises.tech.digitalTwin.k3': 'Real-time data',
    'expertises.tech.digitalTwin.k4': 'Node.js',
    'expertises.tech.digitalTwin.k5': 'Cloud',
    'expertises.tech.blockchain.k1': 'Blockchain',
    'expertises.tech.blockchain.k2': 'Smart contracts',
    'expertises.tech.blockchain.k3': 'Traceability',
    'expertises.tech.blockchain.k4': 'Web3',
    'expertises.tech.blockchain.k5': 'API',
    'expertises.tech.observatories.k1': 'React',
    'expertises.tech.observatories.k2': 'Node.js',
    'expertises.tech.observatories.k3': 'PostgreSQL',
    'expertises.tech.observatories.k4': 'Data visualisation',
    'expertises.tech.observatories.k5': 'REST API',
    'expertises.tech.cloudServices.k1': 'AWS',
    'expertises.tech.cloudServices.k2': 'Docker',
    'expertises.tech.cloudServices.k3': 'Kubernetes',
    'expertises.tech.cloudServices.k4': 'CI/CD',
    'expertises.tech.cloudServices.k5': 'MongoDB',
    'expertises.tech.ecommerceCms.k1': 'React',
    'expertises.tech.ecommerceCms.k2': 'E-commerce',
    'expertises.tech.ecommerceCms.k3': 'CMS',
    'expertises.tech.ecommerceCms.k4': 'Stripe',
    'expertises.tech.ecommerceCms.k5': 'Node.js',
    'expertises.tech.decisionDashboard.k1': 'Machine Learning',
    'expertises.tech.decisionDashboard.k2': 'Python',
    'expertises.tech.decisionDashboard.k3': 'BI & dashboards',
    'expertises.tech.decisionDashboard.k4': 'Predictive analytics',
    'expertises.tech.decisionDashboard.k5': 'IoT',
    'expertises.tech.decisionDashboard.k6': 'API',
    'expertises.tech.iot.k1': 'IoT',
    'expertises.tech.iot.k2': 'MQTT',
    'expertises.tech.iot.k3': 'Sensors',
    'expertises.tech.iot.k4': 'Time series',
    'expertises.tech.iot.k5': 'Cloud',
    'expertises.tech.dataIa.k1': 'Artificial Intelligence',
    'expertises.tech.dataIa.k2': 'Machine Learning',
    'expertises.tech.dataIa.k3': 'Python',
    'expertises.tech.dataIa.k4': 'NLP',
    'expertises.tech.dataIa.k5': 'Big Data',
    'expertises.tech.dataIa.k6': 'API',
    'expertises.tech.crmErp.k1': 'CRM',
    'expertises.tech.crmErp.k2': 'ERP',
    'expertises.tech.crmErp.k3': 'SaaS',
    'expertises.tech.crmErp.k4': 'PostgreSQL',
    'expertises.tech.crmErp.k5': 'API integration',
    'expertises.tech.dataManagement.k1': 'ETL',
    'expertises.tech.dataManagement.k2': 'SQL',
    'expertises.tech.dataManagement.k3': 'Data governance',
    'expertises.tech.dataManagement.k4': 'MongoDB',
    'expertises.tech.dataManagement.k5': 'REST API',
    'expertises.tech.webmobile.k1': 'React',
    'expertises.tech.webmobile.k2': 'Node.js',
    'expertises.tech.webmobile.k3': 'TypeScript',
    'expertises.tech.webmobile.k4': 'Mobile',
    'expertises.tech.webmobile.k5': 'SaaS',
    'expertises.tech.webmobile.k6': 'REST API',
    'expertises.detail.observatories.h1': 'Collaborative web observatories for European research programmes',
    'expertises.detail.observatories.h2': 'Dashboards, maps, and indicators for stakeholders and decision-makers',
    'expertises.detail.observatories.h3': 'Integration with existing data sources, APIs, and reporting workflows',
    'expertises.detail.blockchain.h1': 'End-to-end traceability for agri-food and Mediterranean value chains',
    'expertises.detail.blockchain.h2': 'Producer records, certificates, and proof of origin on distributed ledgers',
    'expertises.detail.blockchain.h3': 'Interfaces for producers, distributors, auditors, and consumers',
    'expertises.detail.cloudServices.h1': 'Scalable hosting, managed databases, and secure cloud architectures',
    'expertises.detail.cloudServices.h2': 'CI/CD pipelines, deployment automation, and operational monitoring',
    'expertises.detail.cloudServices.h3': 'Infrastructure aligned with research platforms and business SaaS needs',
    'expertises.detail.iot.h1': 'Sensor networks, gateways, and real-time data ingestion',
    'expertises.detail.iot.h2': 'Alerts, dashboards, and integration with observatories and digital twins',
    'expertises.detail.iot.h3': 'Solutions for agriculture, living labs, and industrial monitoring',
    'expertises.detail.dataIa.h1': 'Analytics pipelines, machine learning, and intelligent automation',
    'expertises.detail.dataIa.h2': 'Structuring and activating data assets across your platforms',
    'expertises.detail.dataIa.h3': 'Personalised user experiences and smart observatory dashboards',
    'expertises.detail.digitalTwin.h1': 'Real-time digital replicas of assets, processes, and living labs',
    'expertises.detail.digitalTwin.h2': 'IoT integration, simulation, and scenario testing',
    'expertises.detail.digitalTwin.h3': 'Collaborative tools for research and operations teams',

    'pages.solutions.backHome': 'Back to home',
    'pages.solutions.viewExpertise': 'View expertise area',
    'pages.solutions.viewProject': 'Our projects',
    'pages.solutions.visitPlatform': 'Visit the platform',
    'pages.solutions.otherSolutions': 'Our other solutions',

    'pages.solutions.digitalTwin.title': 'Digital Twin',
    'pages.solutions.digitalTwin.lead':
      'Real-time digital replicas of your assets, processes, and living labs — connected to IoT, simulation, and collaborative platforms.',
    'pages.solutions.digitalTwin.body':
      'JASSP designs and deploys digital twins for European research programmes and industry: monitor performance, test scenarios, and optimise operations from urban agriculture to industrial value chains. Our approach combines sensor integration, 3D/visual dashboards, and APIs aligned with your observatories and traceability systems.',
    'pages.solutions.digitalTwin.h1': 'Real-time digital replicas of assets, processes, and living labs',
    'pages.solutions.digitalTwin.h2': 'IoT integration, simulation, and scenario testing',
    'pages.solutions.digitalTwin.h3': 'Collaborative tools for research and operations teams',
    'pages.solutions.digitalTwin.h4': 'Deployed on MedAgriCycle and other PRIMA programmes',

    'pages.solutions.blockchain.title': 'Blockchain & Traceability',
    'pages.solutions.blockchain.lead':
      'Distributed ledgers and smart interfaces for transparent, auditable value chains in agri-food and Mediterranean sectors.',
    'pages.solutions.blockchain.body':
      'We build blockchain platforms that secure producer records, certificates, and proof of origin — with dashboards for producers, distributors, auditors, and consumers. From the Techoney traceability platform to custom registries, JASSP delivers end-to-end solutions integrated with your existing data and observatories.',
    'pages.solutions.blockchain.h1': 'End-to-end traceability for agri-food and Mediterranean value chains',
    'pages.solutions.blockchain.h2': 'Producer records, certificates, and proof of origin on distributed ledgers',
    'pages.solutions.blockchain.h3': 'Interfaces for producers, distributors, auditors, and consumers',
    'pages.solutions.blockchain.h4': 'Proven delivery on European innovation projects (e.g. Techoney)',

    'pages.solutions.eLivingLab.title': 'E-Living Lab',
    'pages.solutions.eLivingLab.alt': 'E-Living Lab collaborative platform',
    'pages.solutions.eLivingLab.lead':
      'Collaborative digital toolbox for climate-resilient urban agriculture, waste valorisation, and living-lab experimentation.',
    'pages.solutions.eLivingLab.body':
      'The E-Living Lab platform powers the MedAgriCycle (Green Urban AgriCycle) programme: digital twin environments, IoT sensor feeds, decision support dashboards, and mobile tools for researchers, farmers, and citizens. JASSP leads WP2 — digital toolbox and platform development — connecting partners across the Mediterranean.',
    'pages.solutions.eLivingLab.h1': 'Digital twin and metaverse-style environments for living labs',
    'pages.solutions.eLivingLab.h2': 'IoT integration and real-time monitoring of urban agriculture sites',
    'pages.solutions.eLivingLab.h3': 'Decision support dashboards and collaborative workflows',
    'pages.solutions.eLivingLab.h4': 'Mobile apps and stakeholder engagement for circular economy pilots',

    'expertises.tech.eLivingLab.k1': 'Digital Twin',
    'expertises.tech.eLivingLab.k2': 'IoT',
    'expertises.tech.eLivingLab.k3': 'Living Lab',
    'expertises.tech.eLivingLab.k4': 'Data viz',
    'expertises.tech.eLivingLab.k5': 'Mobile',
    'expertises.tech.eLivingLab.k6': 'React / Node.js',
    'expertises.detail.decisionDashboard.h1': 'Machine learning models for forecasting, scoring, and anomaly detection',
    'expertises.detail.decisionDashboard.h2': 'Interactive KPIs, filters, maps, and exportable decision support dashboards',
    'expertises.detail.decisionDashboard.h3': 'Dashboards tailored to observatories, traceability, and project reporting',
    'expertises.detail.dataManagement.h1': 'Data governance, master data, and quality rules',
    'expertises.detail.dataManagement.h2': 'APIs, ETL, and integration across observatories and business systems',
    'expertises.detail.dataManagement.h3': 'Reliable reporting pipelines for your teams and funders',
    'expertises.detail.crmErp.h1': 'CRM and ERP tailored to your sales and operations processes',
    'expertises.detail.crmErp.h2': 'Unified commercial, financial, and production workflows',
    'expertises.detail.crmErp.h3': 'Connections to your existing tools and digital platforms',
    'expertises.detail.ecommerceCms.h1': 'Custom online stores and content management platforms',
    'expertises.detail.ecommerceCms.h2': 'Secure payments, catalogues, and editorial workflows',
    'expertises.detail.ecommerceCms.h3': 'Scalable solutions that grow with your business',
    'expertises.detail.webmobile.h1': 'Modern websites, SaaS applications, and mobile tools',
    'expertises.detail.webmobile.h2': 'Full-stack development with clean, maintainable architecture',
    'expertises.detail.webmobile.h3': 'Products that evolve with your organisation and project timelines',

    'dataDriven.banner.h1':
      'Accelerate your industrial digital transformation through technological innovation',
    'dataDriven.banner.lead':
      'JASSP SAS develops modern web, mobile, and cloud solutions for businesses and innovation projects.',
    'dataDriven.banner.cta': 'Get Early Access',
    'dataDriven.aboutNav.whoWeAre': 'Who we are',
    'dataDriven.aboutNav.ourHistory': 'Our history',
    'dataDriven.aboutNav.whyChooseUs': 'Why choose us',
    'dataDriven.whoWeAre.h2': 'Who we are',
    'dataDriven.whoWeAre.body':
      'JASSP SAS is a software development company specialising in web platforms, SaaS, blockchain traceability and digital observatories for research and innovation projects across Europe and the Mediterranean.',
    'dataDriven.features.h2': 'Discover Powerful Features',
    'dataDriven.features.lead':
      'Expert software development company delivering modern web applications, mobile solutions, and digital platforms that drive real business growth.',
    'dataDriven.history.h2': 'Our History',
    'dataDriven.history.body':
      'The company JASSP SAS was created on October 13, 2008, 18 years ago. Its legal form is a Simplified Joint-Stock Company (SAS). In 2023, it was classified as a Small or Medium-Sized Enterprise (SME). The company had no employees.',
    'dataDriven.services.h2': 'Our services',
    'dataDriven.services.lead':
      'We transform complex research and business challenges into powerful, scalable digital platforms — specializing in SaaS, blockchain traceability, and data observatories.',
    'dataDriven.card.observatories.title': 'Digital Observatories & Platforms',
    'dataDriven.card.observatories.body':
      'Design and development of powerful web-based observatories and collaborative platforms for European research and innovation projects.',
    'dataDriven.card.observatories.alt': 'Digital observatories and platforms',
    'dataDriven.card.blockchain.title': 'Blockchain Traceability Systems',
    'dataDriven.card.blockchain.body':
      'Secure and transparent blockchain solutions for supply chain traceability, especially in agri-food and Mediterranean products.',
    'dataDriven.card.blockchain.alt': 'Blockchain traceability',
    'dataDriven.card.webmobile.title': 'Web & Mobile Development',
    'dataDriven.card.webmobile.body':
      'Full-stack development of modern websites, SaaS applications, and mobile tools tailored to complex technical requirements.',
    'dataDriven.card.webmobile.alt': 'Web and mobile development',
    'dataDriven.card.cloud.title': 'Cloud Architecture & Data Management',
    'dataDriven.card.cloud.body':
      'Robust cloud infrastructure, database design, deployment, and maintenance for high-performance digital solutions.',
    'dataDriven.card.cloud.alt': 'Cloud architecture',
    'dataDriven.card.cloudServices.body':
      'Cloud infrastructure, hosting, deployment, and security for scalable, high-availability digital platforms.',
    'dataDriven.card.iot.body':
      'Connected sensors, real-time data collection, and dashboards for agriculture, research, and smart monitoring.',
    'dataDriven.card.dataIa.body':
      'AI-powered analytics, data pipelines, and intelligent dashboards to structure and activate your data assets.',
    'dataDriven.card.digitalTwin.body':
      'Real-time digital replicas of assets and processes, connected to IoT sensors and collaborative research platforms.',
    'dataDriven.card.decisionDashboard.body':
      'Decision support dashboards with machine learning: predictions, alerts, and KPIs for operational and strategic decisions.',
    'dataDriven.card.dataManagement.body':
      'Data governance, integration, quality, and APIs for reliable information across your platforms.',
    'dataDriven.card.crmErp.body':
      'CRM and ERP solutions to unify sales, operations, and production on a single scalable platform.',
    'dataDriven.card.ecommerceCms.body':
      'Custom e-commerce stores and CMS platforms designed to grow with your business and content needs.',
    'dataDriven.card.learnMore': 'Learn more',
    'dataDriven.partners.h3': 'Our Partners',
    'dataDriven.partners.lead': 'PRIMA Projects • European & Mediterranean Research',
    'dataDriven.partners.altPrima': 'PRIMA — Partnership for Research and Innovation in the Mediterranean Area',
    'dataDriven.partners.altEu': 'European Union',
    'dataDriven.partners.altInterreg': 'Interreg',
    'dataDriven.partners.altBpi': 'BPI France',
    'dataDriven.partners.altAnr': 'French National Research Agency (ANR)',
    'dataDriven.partners.altMinEconomie': 'Ministry of the Economy',
    'dataDriven.partners.altTr': 'Türkiye',

    'newsletter.placeholder': 'Enter your email',
    'newsletter.submit': 'Subscribe',
    'newsletter.error.required': 'Field is required',
    'newsletter.error.invalidEmail': 'Invalid email address',
    'newsletter.success.title': 'Success',
    'newsletter.success.body': 'You have successfully subscribed',
    'newsletter.error.title': 'Error',

    'contact.toast.sentTitle': 'Message sent',
    'contact.toast.sentBody': 'Thank you. We have received your message and will get back to you shortly.',
    'contact.toast.errorTitle': 'Message not sent',
    'contact.toast.errorBody': 'An error occurred while sending. Please try again.',
    'contact.toast.smtpAuthFailed':
      'Email server login failed. Use a Gmail App Password (not your normal password) in backend/.env.',
    'contact.toast.smtpNotConfigured':
      'Email is not configured on the server. Set SMTP_HOST, SMTP_USER, and SMTP_PASS in backend/.env.',
    'contact.hero.pageTitle': 'Contact us',
    'contact.hero.kicker': 'Get in Touch with JASSP',
    'contact.hero.h1': 'Ready to Bring Your Digital Project to Life?',
    'contact.hero.lead':
      'Whether you have a research project, need a custom SaaS platform, a blockchain solution, or a digital observatory — our team is ready to help.',
    'contact.join.h2': 'Would you like to join us?',
    'contact.join.cta': 'View job openings',
    'contact.form.submitProject': 'Submit a project',
    'contact.form.h2': 'Send us a message',
    'contact.form.firstName': 'First name',
    'contact.form.lastName': 'Last name',
    'contact.form.company': 'Company name',
    'contact.form.fullName': 'Full name *',
    'contact.form.fullNamePh': 'Your name',
    'contact.form.email': 'Email address *',
    'contact.form.emailPh': 'you@example.com',
    'contact.form.phone': 'Phone number (optional)',
    'contact.form.phonePh': '+33 …',
    'contact.form.projectType': 'Project type *',
    'contact.form.budget': 'Budget range (optional)',
    'contact.form.message': 'Message / project description *',
    'contact.form.messagePh': 'Describe your needs, timeline, and any relevant context…',
    'contact.form.submit': 'Send message',
    'contact.form.sending': 'Sending...',
    'contact.validation.required': 'Required',
    'contact.validation.invalidEmail': 'Invalid email',
    'contact.validation.projectType': 'Please select a project type',
    'contact.validation.message': 'Please enter a message',
    'contact.info.company': 'JASSP SAS',
    'contact.info.address': 'Address',
    'contact.info.email': 'Email',
    'contact.info.phone': 'Phone',
    'contact.info.phoneFrance': '(France)',
    'contact.info.hours': 'Business hours',
    'contact.info.hoursValue': 'Monday – Friday: 9:00 AM – 6:00 PM (CET)',
    'contact.otherWays.h4': 'Other ways to reach us',
    'contact.otherWays.note':
      'Replace the LinkedIn URL and WhatsApp number with your official channels.',
    'contact.why.h2': 'Why contact us',
    'contact.why.li1': 'Fast response time — usually within 24 hours.',
    'contact.why.li2': 'Free initial consultation to clarify scope and fit.',
    'contact.why.li3':
      'Strong experience with European research programmes (PRIMA, Horizon, and similar frameworks).',
    'contact.map.h2': 'Find us',
    'contact.map.iframeTitle': 'JASSP — Champs-sur-Marne',

    'contact.opt.projectType.empty': 'Select project type',
    'contact.opt.projectType.webSaaS': 'Web / SaaS development',
    'contact.opt.projectType.observatory': 'Digital observatory',
    'contact.opt.projectType.blockchain': 'Blockchain & traceability',
    'contact.opt.projectType.mobile': 'Mobile app',
    'contact.opt.projectType.research': 'Research platform',
    'contact.opt.projectType.other': 'Other',
    'contact.opt.budget.empty': 'Budget range (optional)',
    'contact.opt.budget.under10k': 'Under €10,000',
    'contact.opt.budget.10k50k': '€10,000 – €50,000',
    'contact.opt.budget.50k150k': '€50,000 – €150,000',
    'contact.opt.budget.150kPlus': '€150,000+',
    'contact.opt.budget.discuss': 'Prefer to discuss',

    'portfolio.hero.kicker': 'JASSP SAS',
    'portfolio.hero.h1': 'Our Projects',
    'portfolio.hero.h2': 'Turning Research into Powerful Digital Solutions',
    'portfolio.hero.lead':
      'Discover how JASSP transforms complex challenges in agri-food, sustainability, and innovation into robust, user-friendly digital platforms.',
    'portfolio.filter.all': 'All Projects',
    'portfolio.filter.observatories': 'Digital Observatories',
    'portfolio.filter.blockchain': 'Blockchain & Traceability',
    'portfolio.filter.research': 'Research Platforms',
    'portfolio.filter.saas': 'SaaS Solutions',
    'portfolio.filter.mobile': 'Mobile & IoT',
    'portfolio.empty': 'No projects in this category yet.',
    'portfolio.card.role': 'JASSP role:',
    'portfolio.card.tech': 'Technologies:',
    'portfolio.card.visit': 'Visit live platform',
    'portfolio.backHome': 'Back to home',
    'portfolio.adminManaged.role': 'Delivery & platform engineering (JASSP)',
    'portfolio.comments.toggle': 'Comments',
    'portfolio.comments.title': 'Discussion',
    'portfolio.comments.name': 'Your name (optional)',
    'portfolio.comments.message': 'Your comment',
    'portfolio.comments.submit': 'Post',
    'portfolio.comments.posting': 'Sending…',
    'portfolio.comments.empty': 'No comments yet — be the first.',
    'portfolio.comments.loadError': 'Comments could not be loaded. Check that the API is running.',
    'portfolio.comments.postError': 'Could not post your comment.',
    'portfolio.comments.anonymous': 'Visitor',
    'portfolio.comments.hint': 'Comments are public. Be respectful.',

    'portfolio.project.morediet.logoAlt': 'MoreMedDiet Observatory logo',
    'portfolio.project.morediet.title': 'MoreMedDiet – Mediterranean Diet Observatory',
    'portfolio.project.morediet.description':
      'A comprehensive digital platform including a web observatory, NFT marketplace, AI-powered chatbot, and educational game to promote the adoption of a healthy Mediterranean diet.',
    'portfolio.project.morediet.role': 'Technical Lead (WP3) – Full SaaS architecture & development',
    'portfolio.project.morediet.tech': 'MERN Stack, Material Design 3, Blockchain (NFT), AI Integration',

    'portfolio.project.medagricycle.logoAlt': 'MedAgriCycle project logo',
    'portfolio.project.medagricycle.title': 'Green Urban AgriCycle – E-Living Lab Platform',
    'portfolio.project.medagricycle.description':
      'Digital Twin platform with IoT sensor integration, decision support dashboard, and collaborative tools for climate-resilient urban agriculture and waste valorization.',
    'portfolio.project.medagricycle.role': 'Lead of WP2 – Digital Toolbox & Platform Development',
    'portfolio.project.medagricycle.tech': 'Metaverse/Digital Twin, IoT, Data Visualization, Mobile Apps',

    'portfolio.project.techoney.logoAlt': 'Techoney project logo',
    'portfolio.project.techoney.title': 'Techoney – Blockchain Traceability Platform',
    'portfolio.project.techoney.description':
      'Blockchain-powered ecosystem combining e-commerce and full supply chain traceability to empower small honey producers in local and international markets.',
    'portfolio.project.techoney.role': 'Lead Developer & Technical Architect',
    'portfolio.project.techoney.tech': 'React, Symfony, Blockchain (Ethereum + Hyperledger), Stripe, Multi-currency',

    'footer.v2.contactIntro': 'Contact details:',
    'footer.v2.emailLabel': 'Email:',
    'footer.v2.phoneLabel': 'Phone:',
    'footer.v2.addressLabel': 'Address:',
    'footer.v2.pages': 'Pages',
    'footer.v2.utility': 'Utility pages',
    'footer.v2.linkHome': 'Home',
    'footer.v2.linkPortfolio': 'Portfolio',
    'footer.v2.linkRealisations': 'Projects',
    'footer.v2.linkExpertises': 'Expertises',
    'footer.v2.linkPartenaires': 'Partners',
    'footer.v2.linkQuiSommesNous': 'Who we are',
    'footer.v2.linkNotreHistoire': 'Our history',
    'footer.v2.linkPourquoiNousChoisir': 'Why choose us',
    'footer.v2.linkContact': 'Contact',
    'footer.v2.login': 'Login',
    'footer.v2.signup': 'Sign up',
    'footer.v2.resetPassword': 'Reset password',
    'footer.v2.notFound': '404 Not found',
    'footer.v2.rightsReserved': 'All rights reserved.',
    'footer.v2.allRights': 'All rights',
    'footer.v2.terms': 'Terms & conditions',
    'footer.v2.privacy': 'Privacy policy',

    'footer.v1.ctaTitle': 'Create better, build faster',
    'footer.v1.ctaLead':
      'Everything you need to create your next unique and professional website, including impressive and ready-made pages.',
    'footer.v1.purchase': 'Purchase NioLand now',
    'footer.v1.envato': 'Available only on Envato',

    'auth.login.docTitle': 'Login',
    'auth.login.title': 'Login',
    'auth.login.google': 'Sign in with Google',
    'auth.login.sep': 'OR',
    'auth.login.emailLabel': 'Username / Email *',
    'auth.login.passwordLabel': 'Password *',
    'auth.login.recaptcha': 'This site is protected by reCAPTCHA. See Google’s',
    'auth.login.recaptchaPrivacy': 'Privacy Policy',
    'auth.login.recaptchaAnd': 'and',
    'auth.login.recaptchaTerms': 'Terms of Service',
    'auth.login.recaptchaApply': '.',
    'auth.login.submit': 'Login',
    'auth.login.forgot': 'Forgot password?',
    'auth.login.noAccount': "Don't have an account yet?",
    'auth.login.signupLink': 'Create one',
    'auth.login.signupSuccessTitle': 'Account created',
    'auth.login.signupSuccessBody': 'Sign in with your email and password.',
    'auth.login.signupEmailTakenTitle': 'Already registered',
    'auth.login.signupEmailTakenBody': 'This email already has an account. Sign in below.',
    'auth.login.err.required': 'This field is required',
    'auth.login.err.invalidEmail': 'Invalid email address',
    'auth.login.err.invalidCredentials':
      'Unknown email or incorrect password. Only registered users can sign in.',
    'auth.login.err.googleNotRegistered':
      'This Google account does not match a registered profile. Ask an administrator to add your email.',
    'auth.google.err.failed': 'Google sign-in failed.',
    'auth.google.err.popupBlocked':
      'The browser blocked the window. Allow pop-ups or try again.',
    'auth.google.err.generic': 'Could not finish Google sign-in. Try again.',

    'auth.signup.docTitle': 'Create an account',
    'auth.signup.title': 'Create an account',
    'auth.signup.google': 'Sign up with Google',
    'auth.signup.sep': 'OR',
    'auth.signup.name': 'Full name *',
    'auth.signup.email': 'Email *',
    'auth.signup.password': 'Password *',
    'auth.signup.recaptchaLead': 'This site is protected by reCAPTCHA. See Google’s',
    'auth.signup.recaptchaPrivacy': 'Privacy Policy',
    'auth.signup.recaptchaAnd': 'and',
    'auth.signup.recaptchaTerms': 'Terms of Service',
    'auth.signup.recaptchaApply': '.',
    'auth.signup.submit': 'Create my account',
    'auth.signup.hasAccount': 'Already have an account?',
    'auth.signup.loginLink': 'Login',
    'auth.signup.toastOkTitle': 'Success',
    'auth.signup.toastOkBody': 'Registration saved.',
    'auth.signup.toastErrTitle': 'Error',
    'auth.signup.toastErrBody': 'Please fill in the required fields.',
    'auth.signup.err.required': 'This field is required',
    'auth.signup.err.invalidEmail': 'Invalid email address',
    'auth.signup.err.emailTaken': 'This email is already registered.',
    'auth.signup.err.generic': 'Registration failed. Please try again.',

    'auth.forgot.docTitle': 'Forgot password',
    'auth.forgot.toastTitle': 'Success',
    'auth.forgot.toastBody': 'Your password reset link has been sent to your email.',
    'auth.forgot.title': 'Forgot your password?',
    'auth.forgot.sub': "Shouldn't be here?",
    'auth.forgot.loginLink': 'Login',
    'auth.forgot.email': 'Email',
    'auth.forgot.emailPh': 'Enter your email',
    'auth.forgot.submit': 'Send reset link',
    'auth.forgot.err.required': 'This field is required',
    'auth.forgot.err.invalidEmail': 'Invalid email address',

    'auth.reset.docTitle': 'Reset password',
    'auth.reset.title': 'Reset password',
    'auth.reset.sub': "Shouldn't be here?",
    'auth.reset.loginLink': 'Login',
    'auth.reset.password': 'Password',
    'auth.reset.passwordPh': 'At least 8 characters',
    'auth.reset.confirm': 'Confirm password',
    'auth.reset.confirmPh': 'Passwords must match',
    'auth.reset.submit': 'Reset password',

    'pages.admin.docTitle': 'JASSP Admin Panel',
    'admin.layout.brand': 'JASSP admin panel',
    'admin.layout.searchPlaceholder': 'Search projects, users, reports…',
    'admin.top.notifications': 'Notifications',
    'admin.top.profile': 'Administrator',
    'admin.notifications.empty': 'No notifications yet.',
    'admin.notifications.markAllRead': 'Mark all as read',
    'admin.notifications.n1Title': 'New user registration',
    'admin.notifications.n1Body': 'A partner account was created on the platform.',
    'admin.notifications.n2Title': 'Dataset uploaded',
    'admin.notifications.n2Body': 'MoreMedDiet observatory — 2.4 MB file ingested.',
    'admin.notifications.n3Title': 'System alert resolved',
    'admin.notifications.n3Body': 'MedAgriCycle API latency is back to normal.',
    'admin.notifications.timeRecent': 'A few minutes ago',
    'admin.notifications.timeEarlier': 'Earlier today',
    'admin.nav.dashboard': 'Dashboard',
    'admin.nav.projects': 'Project management',
    'admin.nav.domains': 'Project domain management',
    'admin.nav.users': 'User management',
    'admin.nav.data': 'Data Management',
    'admin.nav.observatories': 'Observatories',
    'admin.nav.blockchain': 'Blockchain Traceability',
    'admin.nav.analytics': 'Analytics & Reports',
    'admin.nav.settings': 'Settings',
    'admin.nav.logout': 'Logout',
    'admin.nav.publicSite': 'Public site',

    'admin.crud.usersTitle': 'Users & teams',
    'admin.crud.domainsTitle': 'Project domains',
    'admin.crud.projectsTitle': 'Projects',
    'admin.crud.projectsShowcaseHint':
      'Showcase projects (badge) are listed first; you can edit them, save changes, or delete them like any other project.',
    'admin.crud.addUser': 'Add user',
    'admin.crud.editUser': 'Edit user',
    'admin.crud.addDomain': 'Add domain',
    'admin.crud.editDomain': 'Edit domain',
    'admin.crud.addProject': 'Add project',
    'admin.crud.editProject': 'Edit project',
    'admin.crud.colName': 'Name',
    'admin.crud.colEmail': 'Email',
    'admin.crud.colRole': 'Role',
    'admin.crud.colSlug': 'Slug',
    'admin.crud.colDescription': 'Description',
    'admin.crud.colDomain': 'Domain',
    'admin.crud.colStatus': 'Status',
    'admin.crud.colActions': 'Actions',
    'admin.crud.colVisuals': 'Logo / photo',
    'admin.crud.projectLogo': 'Project logo',
    'admin.crud.projectPhoto': 'Project photo (cover)',
    'admin.crud.removeImage': 'Remove',
    'admin.crud.imageTooLarge': 'Image is too large (max. 512 KB). Choose a smaller file.',
    'admin.crud.imageInvalid': 'Please choose a valid image file.',
    'admin.crud.edit': 'Edit',
    'admin.crud.delete': 'Delete',
    'admin.crud.cancel': 'Cancel',
    'admin.crud.password': 'Password',
    'admin.crud.passwordNew': 'Password *',
    'admin.crud.passwordHintEdit': 'Leave blank to keep the current password.',
    'admin.crud.save': 'Save',
    'admin.crud.confirmDelete': 'Delete this item? This cannot be undone.',
    'admin.crud.domainInUse': 'This domain is used by one or more projects. Remove or reassign those projects first.',
    'admin.crud.noDomainsHint': 'Create at least one project domain before adding projects.',
    'admin.crud.role.admin': 'Admin',
    'admin.crud.role.researcher': 'Researcher',
    'admin.crud.role.partner': 'Partner',
    'admin.crud.role.viewer': 'Viewer',
    'admin.crud.projectStatus.active': 'Active',
    'admin.crud.projectStatus.in_progress': 'In progress',
    'admin.crud.projectStatus.completed': 'Completed',
    'admin.crud.staticProjectBadge': 'Showcase',
    'admin.crud.projectWebsite': 'Website URL',

    'admin.kpi.projects': 'Total Projects',
    'admin.kpi.users': 'Active Users',
    'admin.kpi.dataPoints': 'Data Points Collected',
    'admin.kpi.platforms': 'Platforms Online',
    'admin.kpi.domains': 'Project domains',
    'admin.kpi.activeProjects': 'Active projects',

    'admin.dashboard.domainsTitle': 'Domains overview',
    'admin.dashboard.manageDomains': 'Manage domains',
    'admin.dashboard.projectsInDomain': 'Projects',
    'admin.dashboard.noDomains': 'No domains yet — create one in Project domain management.',
    'admin.dashboard.seeAllProjects': 'See all projects →',
    'admin.dashboard.backendLive': 'Dashboard figures are loaded from the API (MongoDB).',
    'admin.dashboard.backendEmpty':
      'The API responded but the database has no admin records yet — showing local browser data until you sync or create data in MongoDB.',
    'admin.dashboard.backendError': 'Could not reach the API — showing local browser data.',
    'admin.dashboard.apiConnecting': 'Connecting to API…',

    'admin.recent.title': 'Recent Projects',
    'admin.recent.col.project': 'Project',
    'admin.recent.col.status': 'Status',
    'admin.recent.status.active': 'Active',
    'admin.recent.empty': 'No projects yet — add one from Project management.',

    'admin.activity.title': 'Real-time activity',
    'admin.activity.a1': 'New user registration — partner@mmd-observatory.com',
    'admin.activity.a2': 'Dataset upload — MoreMedDiet observatory (2.4 MB)',
    'admin.activity.a3': 'System alert — MedAgriCycle API latency restored',

    'admin.chart.title': 'Analytics overview',
    'admin.chart.subtitle': 'User growth and platform usage (last 30 days)',
    'admin.chart.placeholder': 'Chart area — connect your analytics API',
    'admin.consumption.title': 'Consumption by country',
    'admin.consumption.subtitle': 'Platform usage aggregated by country (last 30 days)',
    'admin.consumption.total': 'Total:',
    'admin.consumption.unit': 'requests',
    'admin.consumption.backendLive': 'Live from API (MongoDB)',
    'admin.consumption.backendError': 'API unavailable — showing sample data.',

    'admin.quick.title': 'Quick actions',
    'admin.quick.newProject': 'New Project',
    'admin.quick.addUser': 'Add User',
    'admin.quick.report': 'Generate Report',
    'admin.quick.deploy': 'Deploy Update',

    'admin.module.projects.title': 'Projects management',
    'admin.module.projects.lead':
      'List of projects with status (Active, In Progress, Completed) and work package tracking. Connect your backend to sync live data.',
    'admin.module.users.title': 'User management',
    'admin.module.users.lead':
      'Roles: Admin, Researcher, Partner, Viewer — with granular permissions. Invite users and manage team access.',
    'admin.module.data.title': 'Data management',
    'admin.module.data.lead':
      'Ingest, validate, and export datasets (CSV / Excel). Pipelines and retention policies can be configured here.',
    'admin.module.observatories.title': 'Data observatory',
    'admin.module.observatories.lead':
      'Live data tables, filters, and export. Linked to PRIMA and research observatory platforms.',
    'admin.module.blockchain.title': 'Blockchain dashboard',
    'admin.module.blockchain.lead':
      'Traceability explorer, transaction logs, and smart contract status for Techoney and related chains.',
    'admin.module.analytics.title': 'Analytics & reports',
    'admin.module.analytics.lead':
      'Advanced charts with filters by country or project. Schedule automated reports for stakeholders.',
    'admin.module.settings.title': 'Settings',
    'admin.module.settings.lead':
      'Organisation profile, API keys, integrations, and environment preferences (staging / production indicators).',

    'admin.settings.title': 'Settings',
    'admin.settings.saved': 'Settings saved successfully.',
    'admin.settings.smtpTitle': 'SMTP Configuration',
    'admin.settings.smtpHost': 'SMTP Host',
    'admin.settings.smtpPort': 'Port',
    'admin.settings.smtpSecure': 'Secure (SSL)',
    'admin.settings.smtpUser': 'SMTP User',
    'admin.settings.smtpPass': 'SMTP Password',
    'admin.settings.smtpFrom': 'From Email',
    'admin.settings.contactTitle': 'Contact Form',
    'admin.settings.contactToEmail': 'Recipient Email',
    'admin.settings.brandingTitle': 'Branding',
    'admin.settings.siteLogo': 'Site Logo',
    'admin.settings.siteFavicon': 'Favicon',
    'admin.settings.noLogo': 'No logo uploaded',
    'admin.settings.noFavicon': 'No favicon uploaded',
    'admin.settings.contactDetailsTitle': 'Contact Details',
    'admin.settings.companyName': 'Company Name',
    'admin.settings.footerEmail': 'Footer Email',
    'admin.settings.contactEmail': 'Contact Page Email',
    'admin.settings.contactPhone': 'Phone',
    'admin.settings.contactAddressLine1': 'Address Line 1',
    'admin.settings.contactAddressLine2': 'Address Line 2',
    'admin.settings.businessHours': 'Business Hours',
    'admin.settings.mapEmbedUrl': 'Map Embed URL',
    'admin.settings.socialTitle': 'Social Media',
    'admin.settings.socialLinkedin': 'LinkedIn URL',
    'admin.settings.socialFacebook': 'Facebook URL',
    'admin.settings.socialTwitter': 'Twitter URL',
    'admin.settings.socialInstagram': 'Instagram URL',
    'admin.settings.socialWhatsapp': 'WhatsApp Number',
    'admin.settings.googleTitle': 'Google OAuth',
    'admin.settings.googleClientId': 'Google Client ID',
    'admin.settings.googleClientSecret': 'Google Client Secret',
    'admin.settings.googleRedirectUri': 'Google Redirect URI',
    'admin.settings.saving': 'Saving...',
    'admin.settings.save': 'Save Settings',

    _navFromEn: {
      Login: 'Login',
      'Sign up': 'Sign up',
      Demos: 'Demos',
      Features: 'Features',
      Portfolio: 'Portfolio',
      Contact: 'Contact',
      Accueil: 'Home',
      Home: 'Home',
      Pricing: 'Pricing',
      About: 'About',
      Blogs: 'Blog',
      'Help Center': 'Help Center',
      Careers: 'Careers',
      Expertises: 'Expertises',
      Partenaires: 'Partners',
      Réalisations: 'Projects',
      Portfolio: 'Projects',
      'Qui sommes-nous': 'Who we are',
      'Notre histoire': 'Our history',
      'Pourquoi nous choisir': 'Why choose us',
      'Nous rejoindre': 'Why choose us',
      Solutions: 'Solutions',
      'Digital Twin': 'Digital Twin',
      Blockchain: 'Blockchain',
      'E-Living Lab': 'E-Living Lab',
    },
    _navFromFr: {
      Login: 'Login',
      Connexion: 'Login',
      Inscription: 'Sign up',
      'Sign up': 'Sign up',
      Demos: 'Demos',
      Démos: 'Demos',
      Features: 'Features',
      Fonctionnalités: 'Features',
      Portfolio: 'Portfolio',
      Contact: 'Contact',
      Accueil: 'Home',
      Home: 'Home',
      Tarifs: 'Pricing',
      Pricing: 'Pricing',
      'À propos': 'About',
      About: 'About',
      Blog: 'Blog',
      Blogs: 'Blog',
      "Centre d'aide": 'Help Center',
      'Help Center': 'Help Center',
      Carrières: 'Careers',
      Careers: 'Careers',
      Expertises: 'Expertises',
      Partenaires: 'Partners',
      Réalisations: 'Projects',
      Portfolio: 'Projects',
      'Qui sommes-nous': 'Who we are',
      'Notre histoire': 'Our history',
      'Pourquoi nous choisir': 'Why choose us',
      'Nous rejoindre': 'Why choose us',
      Solutions: 'Solutions',
      'Digital Twin': 'Digital Twin',
      Blockchain: 'Blockchain',
      'E-Living Lab': 'E-Living Lab',
    },
  },

  fr: {
    'layout.docSuffix': 'JASSP',
    'nav.langMenuTitle': 'Langue',
    'nav.langFr': 'Français',
    'nav.langEn': 'English',
    'nav.logout': 'Déconnexion',
    'nav.adminDashboard': 'Tableau de bord admin',
    'nav.expertises.viewAll': 'Voir toutes les expertises',

    'pages.dataDriven.title': 'Accueil',
    'pages.expertises.title': 'Expertises',
    'pages.quiSommesNous.title': 'Qui sommes-nous',
    'quiSommesNous.hero.brand': 'JASSP SAS',
    'quiSommesNous.hero.tagline': 'Votre partenaire technique pour des solutions digitales sur mesure',
    'quiSommesNous.hero.intro':
      'Depuis 2008, nous transformons les idées complexes en plateformes digitales performantes, particulièrement dans les domaines de la recherche, l’agroalimentaire, la durabilité et la traçabilité.',
    'quiSommesNous.summary':
      'JASSP SAS est une entreprise française spécialisée dans le développement de solutions digitales sur mesure. Nous concevons et développons des plateformes web, observatoires numériques, systèmes de traçabilité blockchain et des solutions SaaS pour des projets de recherche et d’innovation, particulièrement dans les domaines de l’agroalimentaire, de la durabilité et de l’économie circulaire. Avec plus de 16 ans d’expérience et une forte présence dans les projets européens (PRIMA), nous accompagnons les institutions de recherche et les entreprises dans leur transformation digitale.',
    'quiSommesNous.history.h2': 'Notre histoire',
    'quiSommesNous.history.body':
      'Fondée en octobre 2008 à Champs-sur-Marne (France), JASSP SAS est une société spécialisée dans le développement de solutions digitales sur mesure. Avec plus de 16 ans d’expérience, nous accompagnons les projets de recherche européens et méditerranéens (notamment les projets PRIMA) en fournissant l’expertise technique complète : plateformes web, observatoires numériques, solutions blockchain, applications mobiles et architectures SaaS.',
    'quiSommesNous.expertise.h2': 'Notre expertise',
    'quiSommesNous.expertise.lead':
      'Nous sommes spécialisés dans la traduction de besoins scientifiques et techniques complexes en outils digitaux intuitifs et performants.',
    'quiSommesNous.expertise.domainsLabel': 'Domaines d’excellence :',
    'quiSommesNous.expertise.item1': 'Développement Web & SaaS',
    'quiSommesNous.expertise.item2': 'Observatoires numériques et visualisation de données',
    'quiSommesNous.expertise.item3': 'Solutions Blockchain & Traçabilité',
    'quiSommesNous.expertise.item4': 'Plateformes de recherche européennes',
    'quiSommesNous.expertise.item5': 'Applications mobiles et IoT',
    'quiSommesNous.values.h2': 'Nos valeurs',
    'quiSommesNous.values.item1': 'Excellence technique',
    'quiSommesNous.values.item2': 'Innovation',
    'quiSommesNous.values.item3': 'Fiabilité (projets long terme)',
    'quiSommesNous.values.item4': 'Collaboration avec les institutions de recherche',
    'quiSommesNous.values.item5': 'Impact réel sur des projets à vocation sociétale',
    'quiSommesNous.stats.h2': 'Chiffres clés',
    'quiSommesNous.stats.item1': '16 ans d’expérience',
    'quiSommesNous.stats.item2': '3+ grands projets européens en cours (MoreMedDiet, MedAgriCycle, Techoney…)',
    'quiSommesNous.stats.item3': 'Partenaires dans plus de 8 pays méditerranéens',
    'quiSommesNous.stats.item4': 'Projets livrés pour des universités et centres de recherche prestigieux',
    'quiSommesNous.mission.h2': 'Notre mission',
    'quiSommesNous.mission.body':
      'Être le partenaire technique de confiance qui permet aux projets de recherche et aux entreprises d’innover grâce à des solutions digitales robustes, évolutives et adaptées à leurs besoins spécifiques.',
    'pages.notreHistoire.title': 'Notre histoire',
    'notreHistoire.body.p1':
      'Créée en 2008, JASSP SAS est une société française spécialisée dans le développement de solutions digitales sur mesure pour la recherche et l’innovation.',
    'notreHistoire.body.p2':
      'Depuis plus de 16 ans, nous mettons notre expertise technique au service de projets ambitieux dans les domaines de l’agroalimentaire, de la durabilité, de l’économie circulaire et de la traçabilité.',
    'notreHistoire.body.p3':
      'De la conception d’observatoires numériques (MoreMedDiet) aux plateformes blockchain (Techoney), en passant par les outils collaboratifs de Living Labs (MedAgriCycle), nous accompagnons les chercheurs et les institutions dans leur transformation digitale.',
    'notreHistoire.image.alt': 'Histoire de JASSP',
    'pages.pourquoiNousChoisir.title': 'Pourquoi nous choisir',
    'pourquoiNousChoisir.hero.lead':
      'Un partenaire technologique de confiance pour vos projets de recherche et d’innovation',
    'pourquoiNousChoisir.hero.intro':
      'Depuis plus de 16 ans, JASSP SAS conçoit et développe des plateformes numériques sur mesure pour la recherche européenne et méditerranéenne — observatoires, traçabilité blockchain, jumeaux numériques et outils collaboratifs.',
    'pourquoiNousChoisir.image.alt': 'L’équipe JASSP',
    'pourquoiNousChoisir.why.h2': 'Pourquoi choisir JASSP ?',
    'pourquoiNousChoisir.why.item1':
      'Plus de 16 ans d’expertise sur des projets européens et des programmes PRIMA',
    'pourquoiNousChoisir.why.item2':
      'Accompagnement de bout en bout : stratégie, design, développement, cloud et maintenance',
    'pourquoiNousChoisir.why.item3':
      'SaaS, blockchain, IoT, observatoires de données et IA réunis chez un seul partenaire',
    'pourquoiNousChoisir.why.item4':
      'Une structure à taille humaine — échange direct avec des équipes techniques expérimentées',
    'pourquoiNousChoisir.why.item5':
      'Des solutions construites autour de vos contraintes, délais et parties prenantes',
    'pages.nousRejoindre.title': 'Nous rejoindre',
    'nousRejoindre.hero.lead':
      'Construisez avec JASSP la nouvelle génération de plateformes numériques pour la recherche et l’innovation.',
    'nousRejoindre.hero.intro':
      'Nous recherchons en permanence des personnes talentueuses qui partagent notre passion pour la technologie et l’impact. Rejoignez une équipe à taille humaine impliquée dans des projets de recherche et d’innovation européens et méditerranéens porteurs de sens.',
    'nousRejoindre.image.alt': 'L’équipe JASSP',
    'nousRejoindre.why.h2': 'Pourquoi rejoindre JASSP ?',
    'nousRejoindre.why.item1':
      'Participer à des projets de recherche européens ambitieux (PRIMA et au-delà)',
    'nousRejoindre.why.item2':
      'Une équipe à taille humaine où vos idées et vos compétences comptent vraiment',
    'nousRejoindre.why.item3':
      'Des technologies modernes — plateformes web, blockchain, observatoires de données et SaaS',
    'nousRejoindre.why.item4':
      'De la flexibilité et un bon équilibre entre autonomie et collaboration',
    'nousRejoindre.why.item5':
      'Un apprentissage continu et de réelles opportunités d’évolution au sein de l’entreprise',
    'pages.partenaires.title': 'Partenaires',
    'pages.partenaires.lead':
      'JASSP collabore avec des programmes et institutions de recherche européens et méditerranéens — découvrez les organisations avec lesquelles nous travaillons.',
    'partenaires.hero.h1': 'Partenaires',
    'partenaires.intro.summary':
      'Nous collaborons avec des institutions de recherche, universités et centres d’excellence en Europe et en Méditerranée pour transformer les projets scientifiques en solutions digitales concrètes.',
    'partenaires.intro.h2': 'Des partenaires prestigieux à travers le bassin méditerranéen',
    'partenaires.intro.body':
      'Depuis plus de 16 ans, JASSP SAS travaille main dans la main avec des universités et organismes de recherche renommés dans le cadre de projets européens (notamment PRIMA).',
    'partenaires.projects.h2': 'Nos partenaires par projet',
    'partenaires.projects.moreMedDiet.title': 'MoreMedDiet Observatory',
    'partenaires.projects.moreMedDiet.item1': 'Universidad de Extremadura (Coordinateur – Espagne)',
    'partenaires.projects.moreMedDiet.item2': 'University of Parma & University of Florence (Italie)',
    'partenaires.projects.moreMedDiet.item3': 'Damanhour University (Égypte)',
    'partenaires.projects.moreMedDiet.item4': 'Université de Tunis El Manar (Tunisie)',
    'partenaires.projects.moreMedDiet.item5':
      'Centre de Recherche de l’Institut Paul Bocuse & Telecom SudParis (France)',
    'partenaires.projects.moreMedDiet.item6': 'Polytechnic of Leiria (Portugal)',
    'partenaires.projects.medAgriCycle.title': 'MedAgriCycle (Green Urban AgriCycle)',
    'partenaires.projects.medAgriCycle.item1': 'Erciyes University (Coordinateur – Turquie)',
    'partenaires.projects.medAgriCycle.item2': 'Middle East Technical University (METU) & TÜBITAK (Turquie)',
    'partenaires.projects.medAgriCycle.item3': 'University of Reims Champagne-Ardenne (France)',
    'partenaires.projects.medAgriCycle.item4': 'National School of Agriculture of Meknès (Maroc)',
    'partenaires.projects.medAgriCycle.item5':
      'National Research Institute of Rural Engineering, Water and Forests (Tunisie)',
    'partenaires.projects.techoney.title': 'Techoney',
    'partenaires.projects.techoney.item1': 'University of Naples Federico II (Italie)',
    'partenaires.projects.techoney.item2': 'INAT Tunisie',
    'partenaires.projects.techoney.item3': 'CITA (Espagne)',
    'partenaires.projects.techoney.item4': 'University of Mersin (Turquie)',
    'partenaires.projects.techoney.item5': 'Et plusieurs acteurs de la filière apicole',
    'partenaires.funding.h2': 'Programmes de financement',

    'expertises.hero.h1': 'Expertises',
    'expertises.hero.lead':
      'De la stratégie digitale à la maintenance, en passant par le design, l’implémentation, l’hébergement, la data, l’IoT et les plateformes sur mesure pour la recherche et l’innovation.',
    'expertises.section.observatories.body':
      'Nous concevons et développons des observatoires web et des plateformes collaboratives pour les programmes européens de recherche et d’innovation. Nos solutions fédèrent les acteurs, structurent des données complexes et offrent des tableaux de bord clairs — des living labs aux plateformes d’engagement consommateur en filière agroalimentaire et méditerranéenne.',
    'expertises.section.blockchain.body':
      'Nous déployons des systèmes blockchain sécurisés et transparents pour la traçabilité des filières — notamment agroalimentaires et méditerranéennes. De l’enregistrement producteur à la preuve d’origine, nos plateformes renforcent la confiance entre producteurs, distributeurs et consommateurs.',
    'expertises.section.webmobile.body':
      'Nous réalisons sites web, applications SaaS et outils mobiles adaptés à des contextes techniques exigeants. Expertise full-stack, architecture soignée et code maintenable : votre produit évolue avec votre organisation et vos échéances de projet.',
    'expertises.section.cloudServices.title': 'Cloud services',
    'expertises.section.cloudServices.alt': 'Services cloud et infrastructure',
    'expertises.section.cloudServices.body':
      'Une gamme complète de solutions cloud pour vos besoins d’infrastructure, de développement, d’hébergement et de sécurisation des données. Efficacité, flexibilité et fiabilité — hébergement scalable, bases gérées, pipelines CI/CD et supervision pour vos plateformes de recherche et d’activité.',
    'expertises.section.iot.title': 'IoT',
    'expertises.section.iot.alt': 'Internet des objets',
    'expertises.section.iot.body':
      'Nous connectons capteurs, équipements et plateformes pour l’agriculture connectée, les living labs et la surveillance industrielle. De l’ingestion des données aux tableaux de bord temps réel et alertes, nos solutions IoT s’intègrent à vos observatoires, jumeaux numériques et systèmes de traçabilité.',
    'expertises.section.dataIa.title': 'DATA & IA',
    'expertises.section.dataIa.alt': 'Data et intelligence artificielle',
    'expertises.section.dataIa.body':
      'L’IA est au cœur de nos processus et de nos solutions. En combinant expertise humaine et intelligence artificielle, nous concevons des plateformes pour optimiser vos opérations, structurer vos données et personnaliser l’expérience utilisateur — des pipelines analytiques aux tableaux de bord intelligents.',
    'expertises.section.digitalTwin.title': 'Jumeau numérique',
    'expertises.section.digitalTwin.alt': 'Technologie de jumeau numérique',
    'expertises.section.digitalTwin.body':
      'Nous développons des jumeaux numériques qui reflètent en temps réel vos actifs, processus et living labs. En reliant capteurs IoT, modèles de simulation et plateformes collaboratives, nos jumeaux aident équipes de recherche et industriels à suivre les performances, tester des scénarios et optimiser les opérations — de l’agriculture urbaine aux filières industrielles.',
    'expertises.section.decisionDashboard.title': 'Tableau de bord d’aide à la décision — Machine learning',
    'expertises.section.decisionDashboard.alt': 'Tableau de bord d’aide à la décision et machine learning',
    'expertises.section.decisionDashboard.body':
      'Nous concevons des tableaux de bord d’aide à la décision enrichis par le machine learning : modèles prédictifs, détection d’anomalies et recommandations intelligentes transforment des données complexes en informations claires et actionnables pour les décideurs, chercheurs et équipes terrain. Filtres, indicateurs, cartes, alertes et exports sont adaptés à vos observatoires, chaînes de traçabilité et reporting de projet.',
    'expertises.section.dataManagement.title': 'Gestion des données',
    'expertises.section.dataManagement.alt': 'Gestion des données',
    'expertises.section.dataManagement.body':
      'Nous vous accompagnons pour gouverner, intégrer et sécuriser vos données — observatoires, projets de recherche et plateformes métier. Référentiels, règles de qualité, APIs et pipelines de reporting : vos équipes s’appuient sur une information fiable et cohérente.',
    'expertises.section.crmErp.title': 'CRM & ERP',
    'expertises.section.crmErp.alt': 'Systèmes CRM et ERP',
    'expertises.section.crmErp.body':
      'Modernisez et intégrez vos processus de vente, de génération de leads et de gestion avec des solutions CRM et ERP adaptées à votre organisation. Centralisez prospection, finance et production sur une plateforme unifiée, connectée à vos outils existants.',
    'expertises.section.ecommerceCms.title': 'E-commerce & CMS',
    'expertises.section.ecommerceCms.alt': 'E-commerce et gestion de contenu',
    'expertises.section.ecommerceCms.body':
      'Chaque entreprise mérite une solution e-commerce ou CMS à la mesure de ses besoins. Nous concevons et développons boutiques en ligne et plateformes éditoriales évolutives — paiement sécurisé, catalogues et workflows de publication inclus.',
    'expertises.methodology.h2': 'Une méthode pragmatique, construite avec vous',
    'expertises.methodology.lead':
      'Nous combinons cadrage, livraison itérative et collaboration étroite avec vos équipes — observatoire, chaîne de traçabilité ou SaaS sur mesure. Chaque phase est alignée sur vos contraintes, délais et parties prenantes.',
    'expertises.methodology.cta': 'Parlons de votre projet',
    'expertises.linkPortfolio': 'Voir nos projets',
    'expertises.detail.backToAll': 'Toutes les expertises',
    'expertises.detail.readMore': 'En savoir plus',
    'expertises.detail.highlightsTitle': 'Ce que nous proposons',
    'expertises.detail.otherTitle': 'Nos autres expertises',
    'expertises.tech.label': 'Combo technologies',
    'expertises.tech.digitalTwin.k1': 'IoT',
    'expertises.tech.digitalTwin.k2': 'Simulation',
    'expertises.tech.digitalTwin.k3': 'Données temps réel',
    'expertises.tech.digitalTwin.k4': 'Node.js',
    'expertises.tech.digitalTwin.k5': 'Cloud',
    'expertises.tech.blockchain.k1': 'Blockchain',
    'expertises.tech.blockchain.k2': 'Smart contracts',
    'expertises.tech.blockchain.k3': 'Traçabilité',
    'expertises.tech.blockchain.k4': 'Web3',
    'expertises.tech.blockchain.k5': 'API',
    'expertises.tech.observatories.k1': 'React',
    'expertises.tech.observatories.k2': 'Node.js',
    'expertises.tech.observatories.k3': 'PostgreSQL',
    'expertises.tech.observatories.k4': 'Visualisation de données',
    'expertises.tech.observatories.k5': 'API REST',
    'expertises.tech.cloudServices.k1': 'AWS',
    'expertises.tech.cloudServices.k2': 'Docker',
    'expertises.tech.cloudServices.k3': 'Kubernetes',
    'expertises.tech.cloudServices.k4': 'CI/CD',
    'expertises.tech.cloudServices.k5': 'MongoDB',
    'expertises.tech.ecommerceCms.k1': 'React',
    'expertises.tech.ecommerceCms.k2': 'E-commerce',
    'expertises.tech.ecommerceCms.k3': 'CMS',
    'expertises.tech.ecommerceCms.k4': 'Stripe',
    'expertises.tech.ecommerceCms.k5': 'Node.js',
    'expertises.tech.decisionDashboard.k1': 'Machine Learning',
    'expertises.tech.decisionDashboard.k2': 'Python',
    'expertises.tech.decisionDashboard.k3': 'BI & tableaux de bord',
    'expertises.tech.decisionDashboard.k4': 'Analytique prédictive',
    'expertises.tech.decisionDashboard.k5': 'IoT',
    'expertises.tech.decisionDashboard.k6': 'API',
    'expertises.tech.iot.k1': 'IoT',
    'expertises.tech.iot.k2': 'MQTT',
    'expertises.tech.iot.k3': 'Capteurs',
    'expertises.tech.iot.k4': 'Séries temporelles',
    'expertises.tech.iot.k5': 'Cloud',
    'expertises.tech.dataIa.k1': 'Intelligence artificielle',
    'expertises.tech.dataIa.k2': 'Machine Learning',
    'expertises.tech.dataIa.k3': 'Python',
    'expertises.tech.dataIa.k4': 'NLP',
    'expertises.tech.dataIa.k5': 'Big Data',
    'expertises.tech.dataIa.k6': 'API',
    'expertises.tech.crmErp.k1': 'CRM',
    'expertises.tech.crmErp.k2': 'ERP',
    'expertises.tech.crmErp.k3': 'SaaS',
    'expertises.tech.crmErp.k4': 'PostgreSQL',
    'expertises.tech.crmErp.k5': 'Intégration API',
    'expertises.tech.dataManagement.k1': 'ETL',
    'expertises.tech.dataManagement.k2': 'SQL',
    'expertises.tech.dataManagement.k3': 'Gouvernance des données',
    'expertises.tech.dataManagement.k4': 'MongoDB',
    'expertises.tech.dataManagement.k5': 'API REST',
    'expertises.tech.webmobile.k1': 'React',
    'expertises.tech.webmobile.k2': 'Node.js',
    'expertises.tech.webmobile.k3': 'TypeScript',
    'expertises.tech.webmobile.k4': 'Mobile',
    'expertises.tech.webmobile.k5': 'SaaS',
    'expertises.tech.webmobile.k6': 'API REST',
    'expertises.detail.observatories.h1': 'Observatoires web collaboratifs pour programmes de recherche européens',
    'expertises.detail.observatories.h2': 'Tableaux de bord, cartes et indicateurs pour acteurs et décideurs',
    'expertises.detail.observatories.h3': 'Intégration aux sources de données, APIs et workflows de reporting existants',
    'expertises.detail.blockchain.h1': 'Traçabilité de bout en bout pour filières agroalimentaires et méditerranéennes',
    'expertises.detail.blockchain.h2': 'Enregistrements producteurs, certificats et preuves d’origine sur registres distribués',
    'expertises.detail.blockchain.h3': 'Interfaces pour producteurs, distributeurs, auditeurs et consommateurs',
    'expertises.detail.cloudServices.h1': 'Hébergement scalable, bases gérées et architectures cloud sécurisées',
    'expertises.detail.cloudServices.h2': 'Pipelines CI/CD, automatisation des déploiements et supervision opérationnelle',
    'expertises.detail.cloudServices.h3': 'Infrastructure adaptée aux plateformes de recherche et aux besoins SaaS métier',
    'expertises.detail.iot.h1': 'Réseaux de capteurs, passerelles et ingestion de données en temps réel',
    'expertises.detail.iot.h2': 'Alertes, tableaux de bord et intégration aux observatoires et jumeaux numériques',
    'expertises.detail.iot.h3': 'Solutions pour agriculture connectée, living labs et surveillance industrielle',
    'expertises.detail.dataIa.h1': 'Pipelines analytiques, machine learning et automatisation intelligente',
    'expertises.detail.dataIa.h2': 'Structuration et valorisation des données sur vos plateformes',
    'expertises.detail.dataIa.h3': 'Expériences utilisateur personnalisées et tableaux de bord intelligents',
    'expertises.detail.digitalTwin.h1': 'Répliques numériques en temps réel d’actifs, processus et living labs',
    'expertises.detail.digitalTwin.h2': 'Intégration IoT, simulation et tests de scénarios',
    'expertises.detail.digitalTwin.h3': 'Outils collaboratifs pour équipes de recherche et d’exploitation',

    'pages.solutions.backHome': 'Retour à l’accueil',
    'pages.solutions.viewExpertise': 'Voir l’expertise',
    'pages.solutions.viewProject': 'Nos réalisations',
    'pages.solutions.visitPlatform': 'Visiter la plateforme',
    'pages.solutions.otherSolutions': 'Nos autres solutions',

    'pages.solutions.digitalTwin.title': 'Jumeau numérique',
    'pages.solutions.digitalTwin.lead':
      'Répliques numériques en temps réel de vos actifs, processus et living labs — reliées à l’IoT, la simulation et des plateformes collaboratives.',
    'pages.solutions.digitalTwin.body':
      'JASSP conçoit et déploie des jumeaux numériques pour les programmes européens de recherche et l’industrie : suivre les performances, tester des scénarios et optimiser les opérations, de l’agriculture urbaine aux filières industrielles. Notre approche combine capteurs, tableaux de bord visuels/3D et APIs alignées avec vos observatoires et systèmes de traçabilité.',
    'pages.solutions.digitalTwin.h1': 'Répliques numériques en temps réel d’actifs, processus et living labs',
    'pages.solutions.digitalTwin.h2': 'Intégration IoT, simulation et tests de scénarios',
    'pages.solutions.digitalTwin.h3': 'Outils collaboratifs pour équipes de recherche et d’exploitation',
    'pages.solutions.digitalTwin.h4': 'Déployé sur MedAgriCycle et d’autres programmes PRIMA',

    'pages.solutions.blockchain.title': 'Blockchain & traçabilité',
    'pages.solutions.blockchain.lead':
      'Registres distribués et interfaces pour des filières transparentes et auditables en agroalimentaire et en Méditerranée.',
    'pages.solutions.blockchain.body':
      'Nous développons des plateformes blockchain qui sécurisent les enregistrements producteurs, certificats et preuves d’origine — avec des tableaux de bord pour producteurs, distributeurs, auditeurs et consommateurs. De la plateforme Techoney aux registres sur mesure, JASSP livre des solutions de bout en bout intégrées à vos données et observatoires.',
    'pages.solutions.blockchain.h1': 'Traçabilité de bout en bout pour filières agroalimentaires et méditerranéennes',
    'pages.solutions.blockchain.h2': 'Enregistrements producteurs, certificats et preuves d’origine sur registres distribués',
    'pages.solutions.blockchain.h3': 'Interfaces pour producteurs, distributeurs, auditeurs et consommateurs',
    'pages.solutions.blockchain.h4': 'Livraisons éprouvées sur projets d’innovation européens (ex. Techoney)',

    'pages.solutions.eLivingLab.title': 'E-Living Lab',
    'pages.solutions.eLivingLab.alt': 'Plateforme collaborative E-Living Lab',
    'pages.solutions.eLivingLab.lead':
      'Boîte à outils numérique collaborative pour l’agriculture urbaine résiliente, la valorisation des déchets et l’expérimentation en living lab.',
    'pages.solutions.eLivingLab.body':
      'La plateforme E-Living Lab soutient le programme MedAgriCycle (Green Urban AgriCycle) : environnements de jumeau numérique, flux capteurs IoT, tableaux de bord d’aide à la décision et outils mobiles pour chercheurs, agriculteurs et citoyens. JASSP pilote le WP2 — boîte à outils numérique et développement de la plateforme — en fédérant les partenaires autour de la Méditerranée.',
    'pages.solutions.eLivingLab.h1': 'Jumeau numérique et environnements type métavers pour living labs',
    'pages.solutions.eLivingLab.h2': 'Intégration IoT et suivi temps réel des sites d’agriculture urbaine',
    'pages.solutions.eLivingLab.h3': 'Tableaux de bord d’aide à la décision et workflows collaboratifs',
    'pages.solutions.eLivingLab.h4': 'Applications mobiles et engagement des parties prenantes pour pilotes d’économie circulaire',

    'expertises.tech.eLivingLab.k1': 'Jumeau numérique',
    'expertises.tech.eLivingLab.k2': 'IoT',
    'expertises.tech.eLivingLab.k3': 'Living Lab',
    'expertises.tech.eLivingLab.k4': 'Data viz',
    'expertises.tech.eLivingLab.k5': 'Mobile',
    'expertises.tech.eLivingLab.k6': 'React / Node.js',
    'expertises.detail.decisionDashboard.h1': 'Modèles de machine learning : prévisions, scoring et détection d’anomalies',
    'expertises.detail.decisionDashboard.h2': 'Indicateurs interactifs, filtres, cartes et tableaux de bord exportables',
    'expertises.detail.decisionDashboard.h3': 'Adaptés aux observatoires, traçabilité et reporting de projet',
    'expertises.detail.dataManagement.h1': 'Gouvernance des données, référentiels et règles de qualité',
    'expertises.detail.dataManagement.h2': 'APIs, ETL et intégration entre observatoires et systèmes métier',
    'expertises.detail.dataManagement.h3': 'Pipelines de reporting fiables pour vos équipes et financeurs',
    'expertises.detail.crmErp.h1': 'CRM et ERP adaptés à vos processus commerciaux et opérationnels',
    'expertises.detail.crmErp.h2': 'Workflows unifiés pour prospection, finance et production',
    'expertises.detail.crmErp.h3': 'Connexion à vos outils et plateformes numériques existants',
    'expertises.detail.ecommerceCms.h1': 'Boutiques en ligne et plateformes de gestion de contenu sur mesure',
    'expertises.detail.ecommerceCms.h2': 'Paiement sécurisé, catalogues et workflows éditoriaux',
    'expertises.detail.ecommerceCms.h3': 'Solutions évolutives qui accompagnent votre croissance',
    'expertises.detail.webmobile.h1': 'Sites web modernes, applications SaaS et outils mobiles',
    'expertises.detail.webmobile.h2': 'Développement full-stack avec architecture propre et maintenable',
    'expertises.detail.webmobile.h3': 'Produits qui évoluent avec votre organisation et vos échéances de projet',
    'pages.contact.title': 'Contact',
    'pages.portfolio.title': 'Nos projets',
    'pages.realisations.title': 'Réalisations',

    'realisations.hero.h1': 'Réalisations',
    'realisations.hero.leadBefore': 'Une agence qui travaille pour ses clients c’est bien, ',
    'realisations.hero.leadHighlight': 'avec ses clients',
    'realisations.hero.leadAfter': ' c’est mieux',
    'realisations.filter.label': 'Filtrer par :',
    'realisations.card.genericDescription':
      'Plateforme numérique sur mesure réalisée par JASSP SAS pour la recherche et l’innovation.',

    'dataDriven.banner.h1':
      'Accélérez votre transformation digitale industrielle grâce à l’innovation technologique',
    'dataDriven.banner.lead':
      'JASSP SAS développe des solutions web, mobiles et cloud modernes pour les entreprises et les projets d’innovation.',
    'dataDriven.banner.cta': 'Accès anticipé',
    'dataDriven.aboutNav.whoWeAre': 'Qui sommes-nous',
    'dataDriven.aboutNav.ourHistory': 'Notre histoire',
    'dataDriven.aboutNav.whyChooseUs': 'Pourquoi nous choisir',
    'dataDriven.whoWeAre.h2': 'Qui sommes-nous',
    'dataDriven.whoWeAre.body':
      'JASSP SAS est une société de développement logiciel spécialisée dans les plateformes web, le SaaS, la traçabilité blockchain et les observatoires numériques pour la recherche et l’innovation en Europe et en Méditerranée.',
    'dataDriven.features.h2': 'Découvrez des fonctionnalités puissantes',
    'dataDriven.features.lead':
      'Expert en développement logiciel : applications web, solutions mobiles et plateformes numériques au service de la croissance.',
    'dataDriven.history.h2': 'Notre histoire',
    'dataDriven.history.body':
      'La société JASSP SAS a été créée le 13 octobre 2008, il y a 18 ans. Sa forme juridique est une SAS. En 2023, elle était classée PME. La société n’avait pas de salariés.',
    'dataDriven.services.h2': 'Nos services',
    'dataDriven.services.lead':
      'Nous transformons les enjeux complexes de la recherche et des entreprises en plateformes numériques puissantes et évolutives — avec une expertise SaaS, traçabilité blockchain et observatoires de données.',
    'dataDriven.card.observatories.title': 'Observatoires & plateformes numériques',
    'dataDriven.card.observatories.body':
      'Conception et développement d’observatoires web et de plateformes collaboratives pour la recherche et l’innovation européennes.',
    'dataDriven.card.observatories.alt': 'Observatoires et plateformes numériques',
    'dataDriven.card.blockchain.title': 'Traçabilité blockchain',
    'dataDriven.card.blockchain.body':
      'Solutions blockchain sécurisées et transparentes pour la traçabilité des filières, notamment agroalimentaires et méditerranéennes.',
    'dataDriven.card.blockchain.alt': 'Traçabilité blockchain',
    'dataDriven.card.webmobile.title': 'Développement web & mobile',
    'dataDriven.card.webmobile.body':
      'Développement full-stack de sites modernes, applications SaaS et outils mobiles pour des besoins techniques exigeants.',
    'dataDriven.card.webmobile.alt': 'Développement web et mobile',
    'dataDriven.card.cloud.title': 'Cloud & gestion des données',
    'dataDriven.card.cloud.body':
      'Infrastructure cloud, bases de données, déploiement et maintenance pour des solutions numériques performantes.',
    'dataDriven.card.cloud.alt': 'Architecture cloud',
    'dataDriven.card.cloudServices.body':
      'Infrastructure cloud, hébergement, déploiement et sécurité pour des plateformes numériques scalables et disponibles.',
    'dataDriven.card.iot.body':
      'Capteurs connectés, collecte de données en temps réel et tableaux de bord pour l’agriculture, la recherche et la supervision.',
    'dataDriven.card.dataIa.body':
      'Analytique, pipelines de données et tableaux de bord intelligents pour structurer et valoriser vos données.',
    'dataDriven.card.digitalTwin.body':
      'Répliques numériques en temps réel d’actifs et de processus, connectées aux capteurs IoT et aux plateformes de recherche.',
    'dataDriven.card.decisionDashboard.body':
      'Tableaux de bord d’aide à la décision avec machine learning : prévisions, alertes et indicateurs pour vos décisions opérationnelles et stratégiques.',
    'dataDriven.card.dataManagement.body':
      'Gouvernance, intégration, qualité des données et APIs pour une information fiable sur vos plateformes.',
    'dataDriven.card.crmErp.body':
      'Solutions CRM et ERP pour unifier ventes, opérations et production sur une plateforme évolutive.',
    'dataDriven.card.ecommerceCms.body':
      'Boutiques en ligne et CMS sur mesure, conçus pour accompagner votre croissance et vos contenus.',
    'dataDriven.card.learnMore': 'En savoir plus',
    'dataDriven.partners.h3': 'Nos partenaires',
    'dataDriven.partners.lead': 'Projets PRIMA • Recherche européenne & méditerranéenne',
    'dataDriven.partners.altPrima': 'PRIMA — Partenariat pour la recherche et l’innovation en Méditerranée',
    'dataDriven.partners.altEu': 'Union européenne',
    'dataDriven.partners.altInterreg': 'Interreg',
    'dataDriven.partners.altBpi': 'BPI France',
    'dataDriven.partners.altAnr': 'Agence nationale de la recherche',
    'dataDriven.partners.altMinEconomie': 'Ministère de l’Économie',
    'dataDriven.partners.altTr': 'Türkiye',

    'newsletter.placeholder': 'Votre adresse e-mail',
    'newsletter.submit': "S'inscrire",
    'newsletter.error.required': 'Champ obligatoire',
    'newsletter.error.invalidEmail': 'Adresse e-mail invalide',
    'newsletter.success.title': 'Succès',
    'newsletter.success.body': 'Vous êtes bien inscrit à la newsletter',
    'newsletter.error.title': 'Erreur',

    'contact.toast.sentTitle': 'Message envoyé',
    'contact.toast.sentBody': 'Merci. Nous avons bien reçu votre message et vous répondrons rapidement.',
    'contact.toast.errorTitle': 'Message non envoyé',
    'contact.toast.errorBody': "Une erreur s'est produite lors de l'envoi. Veuillez réessayer.",
    'contact.toast.smtpAuthFailed':
      "Connexion au serveur mail refusée. Utilisez un mot de passe d'application Gmail (pas votre mot de passe habituel) dans backend/.env.",
    'contact.toast.smtpNotConfigured':
      "L'envoi d'e-mails n'est pas configuré sur le serveur. Définissez SMTP_HOST, SMTP_USER et SMTP_PASS dans backend/.env.",
    'contact.hero.pageTitle': 'Nous contacter',
    'contact.hero.kicker': 'Contactez JASSP',
    'contact.hero.h1': 'Prêt à concrétiser votre projet numérique ?',
    'contact.hero.lead':
      'Projet de recherche, plateforme SaaS sur mesure, solution blockchain ou observatoire numérique — notre équipe est à votre écoute.',
    'contact.join.h2': 'Vous souhaitez nous rejoindre ?',
    'contact.join.cta': "Voir les offres d'emplois",
    'contact.form.submitProject': 'Soumettre un projet',
    'contact.form.h2': 'Envoyez-nous un message',
    'contact.form.firstName': 'Prénom',
    'contact.form.lastName': 'Nom',
    'contact.form.company': 'Raison sociale',
    'contact.form.fullName': 'Nom complet *',
    'contact.form.fullNamePh': 'Votre nom',
    'contact.form.email': 'Adresse e-mail *',
    'contact.form.emailPh': 'vous@exemple.com',
    'contact.form.phone': 'Téléphone (optionnel)',
    'contact.form.phonePh': '+33 …',
    'contact.form.projectType': 'Type de projet *',
    'contact.form.budget': 'Budget (optionnel)',
    'contact.form.message': 'Message / description du projet *',
    'contact.form.messagePh': 'Décrivez vos besoins, délais et contexte…',
    'contact.form.submit': 'Envoyer le message',
    'contact.form.sending': 'Envoi...',
    'contact.validation.required': 'Champ obligatoire',
    'contact.validation.invalidEmail': 'E-mail invalide',
    'contact.validation.projectType': 'Veuillez choisir un type de projet',
    'contact.validation.message': 'Veuillez saisir un message',
    'contact.info.company': 'JASSP SAS',
    'contact.info.address': 'Adresse',
    'contact.info.email': 'E-mail',
    'contact.info.phone': 'Téléphone',
    'contact.info.phoneFrance': '(France)',
    'contact.info.hours': 'Horaires',
    'contact.info.hoursValue': 'Lundi – vendredi : 9h00 – 18h00 (CET)',
    'contact.otherWays.h4': 'Autres moyens de contact',
    'contact.otherWays.note':
      'Remplacez l’URL LinkedIn et le numéro WhatsApp par vos canaux officiels.',
    'contact.why.h2': 'Pourquoi nous contacter',
    'contact.why.li1': 'Réponse rapide — en général sous 24 heures.',
    'contact.why.li2': 'Premier échange gratuit pour cadrer le besoin.',
    'contact.why.li3':
      'Expérience solide des programmes européens de recherche (PRIMA, Horizon, etc.).',
    'contact.map.h2': 'Nous trouver',
    'contact.map.iframeTitle': 'JASSP — Champs-sur-Marne',

    'contact.opt.projectType.empty': 'Type de projet',
    'contact.opt.projectType.webSaaS': 'Développement Web / SaaS',
    'contact.opt.projectType.observatory': 'Observatoire numérique',
    'contact.opt.projectType.blockchain': 'Blockchain & traçabilité',
    'contact.opt.projectType.mobile': 'Application mobile',
    'contact.opt.projectType.research': 'Plateforme de recherche',
    'contact.opt.projectType.other': 'Autre',
    'contact.opt.budget.empty': 'Fourchette de budget (optionnel)',
    'contact.opt.budget.under10k': 'Moins de 10 000 €',
    'contact.opt.budget.10k50k': '10 000 € – 50 000 €',
    'contact.opt.budget.50k150k': '50 000 € – 150 000 €',
    'contact.opt.budget.150kPlus': 'Plus de 150 000 €',
    'contact.opt.budget.discuss': 'À discuter ensemble',

    'portfolio.hero.kicker': 'JASSP SAS',
    'portfolio.hero.h1': 'Nos projets',
    'portfolio.hero.h2': 'De la recherche à des solutions numériques puissantes',
    'portfolio.hero.lead':
      'Découvrez comment JASSP transforme les enjeux agroalimentaires, durabilité et innovation en plateformes robustes et simples d’usage.',
    'portfolio.filter.all': 'Tous les projets',
    'portfolio.filter.observatories': 'Observatoires numériques',
    'portfolio.filter.blockchain': 'Blockchain & traçabilité',
    'portfolio.filter.research': 'Plateformes de recherche',
    'portfolio.filter.saas': 'Solutions SaaS',
    'portfolio.filter.mobile': 'Mobile & IoT',
    'portfolio.empty': 'Aucun projet dans cette catégorie pour le moment.',
    'portfolio.card.role': 'Rôle JASSP :',
    'portfolio.card.tech': 'Technologies :',
    'portfolio.card.visit': 'Voir la plateforme',
    'portfolio.backHome': "Retour à l'accueil",
    'portfolio.adminManaged.role': 'Ingénierie & plateformes (JASSP)',
    'portfolio.comments.toggle': 'Commentaires',
    'portfolio.comments.title': 'Discussion',
    'portfolio.comments.name': 'Votre nom (facultatif)',
    'portfolio.comments.message': 'Votre commentaire',
    'portfolio.comments.submit': 'Publier',
    'portfolio.comments.posting': 'Envoi…',
    'portfolio.comments.empty': 'Aucun commentaire pour le moment — soyez le premier.',
    'portfolio.comments.loadError': 'Impossible de charger les commentaires. Vérifiez que l’API est démarrée.',
    'portfolio.comments.postError': 'Impossible de publier votre commentaire.',
    'portfolio.comments.anonymous': 'Visiteur',
    'portfolio.comments.hint': 'Les commentaires sont publics. Restez respectueux.',

    'portfolio.project.morediet.logoAlt': 'Logo observatoire MoreMedDiet',
    'portfolio.project.morediet.title': 'MoreMedDiet – Observatoire du régime méditerranéen',
    'portfolio.project.morediet.description':
      'Plateforme numérique complète : observatoire web, marketplace NFT, chatbot IA et jeu éducatif pour promouvoir une alimentation méditerranéenne saine.',
    'portfolio.project.morediet.role': 'Responsable technique (WP3) – Architecture & développement SaaS',
    'portfolio.project.morediet.tech': 'MERN, Material Design 3, Blockchain (NFT), IA',

    'portfolio.project.medagricycle.logoAlt': 'Logo projet MedAgriCycle',
    'portfolio.project.medagricycle.title': 'Green Urban AgriCycle – Plateforme E-Living Lab',
    'portfolio.project.medagricycle.description':
      'Jumeau numérique avec capteurs IoT, tableau de bord d’aide à la décision et outils collaboratifs pour une agriculture urbaine résiliente et la valorisation des déchets.',
    'portfolio.project.medagricycle.role': 'Chef de WP2 – Boîte à outils numérique & plateforme',
    'portfolio.project.medagricycle.tech': 'Métavers / jumeau numérique, IoT, visualisation de données, apps mobiles',

    'portfolio.project.techoney.logoAlt': 'Logo projet Techoney',
    'portfolio.project.techoney.title': 'Techoney – Plateforme de traçabilité blockchain',
    'portfolio.project.techoney.description':
      'Écosystème blockchain mêlant e-commerce et traçabilité complète de la filière pour les petits producteurs de miel.',
    'portfolio.project.techoney.role': 'Lead développeur & architecte technique',
    'portfolio.project.techoney.tech': 'React, Symfony, Blockchain (Ethereum + Hyperledger), Stripe, multi-devises',

    'footer.v2.contactIntro': 'Coordonnées :',
    'footer.v2.emailLabel': 'E-mail :',
    'footer.v2.phoneLabel': 'Téléphone :',
    'footer.v2.addressLabel': 'Adresse :',
    'footer.v2.pages': 'Pages',
    'footer.v2.utility': 'Pages utilitaires',
    'footer.v2.linkHome': 'Accueil',
    'footer.v2.linkPortfolio': 'Portfolio',
    'footer.v2.linkRealisations': 'Réalisations',
    'footer.v2.linkExpertises': 'Expertises',
    'footer.v2.linkPartenaires': 'Partenaires',
    'footer.v2.linkQuiSommesNous': 'Qui sommes-nous',
    'footer.v2.linkNotreHistoire': 'Notre histoire',
    'footer.v2.linkPourquoiNousChoisir': 'Pourquoi nous choisir',
    'footer.v2.linkContact': 'Contact',
    'footer.v2.login': 'Connexion',
    'footer.v2.signup': 'Inscription',
    'footer.v2.resetPassword': 'Réinitialiser le mot de passe',
    'footer.v2.notFound': '404 — Page introuvable',
    'footer.v2.rightsReserved': 'Tous droits réservés.',
    'footer.v2.allRights': 'Tous droits',
    'footer.v2.terms': 'Conditions générales',
    'footer.v2.privacy': 'Politique de confidentialité',

    'footer.v1.ctaTitle': 'Créez mieux, construisez plus vite',
    'footer.v1.ctaLead':
      'Tout pour créer votre prochain site professionnel, avec des pages prêtes à l’emploi.',
    'footer.v1.purchase': 'Acheter NioLand',
    'footer.v1.envato': 'Disponible sur Envato',

    'auth.login.docTitle': 'Connexion',
    'auth.login.title': 'Connexion',
    'auth.login.google': 'Se connecter avec Google',
    'auth.login.sep': 'OU',
    'auth.login.emailLabel': "Nom d'utilisateur / E-mail *",
    'auth.login.passwordLabel': 'Mot de passe *',
    'auth.login.recaptcha': 'Ce site est protégé par reCAPTCHA. Les règles de',
    'auth.login.recaptchaPrivacy': 'confidentialité',
    'auth.login.recaptchaAnd': 'et les',
    'auth.login.recaptchaTerms': 'conditions',
    'auth.login.recaptchaApply': 'de Google s’appliquent.',
    'auth.login.submit': 'Connexion',
    'auth.login.forgot': 'Mot de passe oublié ?',
    'auth.login.noAccount': 'Pas encore de compte ?',
    'auth.login.signupLink': 'Créez-en un',
    'auth.login.signupSuccessTitle': 'Compte créé',
    'auth.login.signupSuccessBody': 'Connectez-vous avec votre e-mail et votre mot de passe.',
    'auth.login.signupEmailTakenTitle': 'Compte existant',
    'auth.login.signupEmailTakenBody': 'Cette adresse est déjà enregistrée. Connectez-vous ci-dessous.',
    'auth.login.err.required': 'Ce champ est requis',
    'auth.login.err.invalidEmail': 'Adresse e-mail invalide',
    'auth.login.err.invalidCredentials':
      'E-mail inconnu ou mot de passe incorrect. Seuls les utilisateurs enregistrés peuvent se connecter.',
    'auth.login.err.googleNotRegistered':
      'Ce compte Google ne correspond pas à un profil enregistré. Demandez à un administrateur d’ajouter votre e-mail.',
    'auth.google.err.failed': 'La connexion Google a échoué.',
    'auth.google.err.popupBlocked':
      'Le navigateur a bloqué la fenêtre. Autorisez les pop-ups ou réessayez.',
    'auth.google.err.generic':
      'Connexion Google impossible pour le moment. Réessayez.',

    'auth.signup.docTitle': 'Créer un compte',
    'auth.signup.title': 'Créer un compte',
    'auth.signup.google': 'S’inscrire avec Google',
    'auth.signup.sep': 'OU',
    'auth.signup.name': 'Nom complet *',
    'auth.signup.email': 'E-mail *',
    'auth.signup.password': 'Mot de passe *',
    'auth.signup.recaptchaLead': 'Ce site est protégé par reCAPTCHA. Les règles de',
    'auth.signup.recaptchaPrivacy': 'confidentialité',
    'auth.signup.recaptchaAnd': 'et les',
    'auth.signup.recaptchaTerms': 'conditions',
    'auth.signup.recaptchaApply': 'de Google s’appliquent.',
    'auth.signup.submit': 'Créer mon compte',
    'auth.signup.hasAccount': 'Déjà un compte ?',
    'auth.signup.loginLink': 'Connexion',
    'auth.signup.toastOkTitle': 'Succès',
    'auth.signup.toastOkBody': 'Inscription enregistrée.',
    'auth.signup.toastErrTitle': 'Erreur',
    'auth.signup.toastErrBody': 'Veuillez remplir les champs requis.',
    'auth.signup.err.required': 'Ce champ est requis',
    'auth.signup.err.invalidEmail': 'Adresse e-mail invalide',
    'auth.signup.err.emailTaken': 'Cette adresse e-mail est déjà utilisée.',
    'auth.signup.err.generic': 'L’inscription a échoué. Veuillez réessayer.',

    'auth.forgot.docTitle': 'Mot de passe oublié',
    'auth.forgot.toastTitle': 'Succès',
    'auth.forgot.toastBody': 'Le lien de réinitialisation a été envoyé à votre adresse e-mail.',
    'auth.forgot.title': 'Mot de passe oublié ?',
    'auth.forgot.sub': 'Pas au bon endroit ?',
    'auth.forgot.loginLink': 'Connexion',
    'auth.forgot.email': 'E-mail',
    'auth.forgot.emailPh': 'Saisissez votre e-mail',
    'auth.forgot.submit': 'Envoyer le lien',
    'auth.forgot.err.required': 'Ce champ est requis',
    'auth.forgot.err.invalidEmail': 'Adresse e-mail invalide',

    'auth.reset.docTitle': 'Réinitialiser le mot de passe',
    'auth.reset.title': 'Réinitialiser le mot de passe',
    'auth.reset.sub': 'Pas au bon endroit ?',
    'auth.reset.loginLink': 'Connexion',
    'auth.reset.password': 'Mot de passe',
    'auth.reset.passwordPh': 'Au moins 8 caractères',
    'auth.reset.confirm': 'Confirmer le mot de passe',
    'auth.reset.confirmPh': 'Les mots de passe doivent correspondre',
    'auth.reset.submit': 'Réinitialiser',

    'pages.admin.docTitle': 'Panneau admin JASSP',
    'admin.layout.brand': 'Panneau admin JASSP',
    'admin.layout.searchPlaceholder': 'Rechercher projets, utilisateurs, rapports…',
    'admin.top.notifications': 'Notifications',
    'admin.top.profile': 'Administrateur',
    'admin.notifications.empty': 'Aucune notification pour le moment.',
    'admin.notifications.markAllRead': 'Tout marquer comme lu',
    'admin.notifications.n1Title': 'Nouvelle inscription',
    'admin.notifications.n1Body': 'Un compte partenaire a été créé sur la plateforme.',
    'admin.notifications.n2Title': 'Jeu de données importé',
    'admin.notifications.n2Body': 'Observatoire MoreMedDiet — fichier de 2,4 Mo ingéré.',
    'admin.notifications.n3Title': 'Alerte système levée',
    'admin.notifications.n3Body': 'La latence de l’API MedAgriCycle est revenue à la normale.',
    'admin.notifications.timeRecent': 'Il y a quelques minutes',
    'admin.notifications.timeEarlier': 'Plus tôt aujourd’hui',
    'admin.nav.dashboard': 'Tableau de bord',
    'admin.nav.projects': 'Gestion des projets',
    'admin.nav.domains': 'Gestion des domaines des projets',
    'admin.nav.users': 'Gestion des utilisateurs',
    'admin.nav.data': 'Gestion des données',
    'admin.nav.observatories': 'Observatoires',
    'admin.nav.blockchain': 'Traçabilité blockchain',
    'admin.nav.analytics': 'Analytique & rapports',
    'admin.nav.settings': 'Paramètres',
    'admin.nav.logout': 'Déconnexion',
    'admin.nav.publicSite': 'Site public',

    'admin.crud.usersTitle': 'Utilisateurs & équipes',
    'admin.crud.domainsTitle': 'Domaines de projets',
    'admin.crud.projectsTitle': 'Projets',
    'admin.crud.projectsShowcaseHint':
      'Les projets vitrine (badge) sont listés en premier ; vous pouvez les modifier, enregistrer ou les supprimer comme les autres.',
    'admin.crud.addUser': 'Ajouter un utilisateur',
    'admin.crud.editUser': 'Modifier l’utilisateur',
    'admin.crud.addDomain': 'Ajouter un domaine',
    'admin.crud.editDomain': 'Modifier le domaine',
    'admin.crud.addProject': 'Ajouter un projet',
    'admin.crud.editProject': 'Modifier le projet',
    'admin.crud.colName': 'Nom',
    'admin.crud.colEmail': 'E-mail',
    'admin.crud.colRole': 'Rôle',
    'admin.crud.colSlug': 'Identifiant (slug)',
    'admin.crud.colDescription': 'Description',
    'admin.crud.colDomain': 'Domaine',
    'admin.crud.colStatus': 'Statut',
    'admin.crud.colActions': 'Actions',
    'admin.crud.colVisuals': 'Logo / photo',
    'admin.crud.projectLogo': 'Logo du projet',
    'admin.crud.projectPhoto': 'Photo du projet (couverture)',
    'admin.crud.removeImage': 'Retirer',
    'admin.crud.imageTooLarge': 'Image trop volumineuse (max. 512 Ko). Choisissez un fichier plus léger.',
    'admin.crud.imageInvalid': 'Veuillez choisir un fichier image valide.',
    'admin.crud.edit': 'Modifier',
    'admin.crud.delete': 'Supprimer',
    'admin.crud.cancel': 'Annuler',
    'admin.crud.password': 'Mot de passe',
    'admin.crud.passwordNew': 'Mot de passe *',
    'admin.crud.passwordHintEdit': 'Laisser vide pour conserver le mot de passe actuel.',
    'admin.crud.save': 'Enregistrer',
    'admin.crud.confirmDelete': 'Supprimer cet élément ? Cette action est irréversible.',
    'admin.crud.domainInUse': 'Ce domaine est utilisé par un ou plusieurs projets. Supprimez ou réaffectez ces projets d’abord.',
    'admin.crud.noDomainsHint': 'Créez au moins un domaine de projet avant d’ajouter des projets.',
    'admin.crud.role.admin': 'Administrateur',
    'admin.crud.role.researcher': 'Chercheur',
    'admin.crud.role.partner': 'Partenaire',
    'admin.crud.role.viewer': 'Lecteur',
    'admin.crud.projectStatus.active': 'Actif',
    'admin.crud.projectStatus.in_progress': 'En cours',
    'admin.crud.projectStatus.completed': 'Terminé',
    'admin.crud.staticProjectBadge': 'Vitrine',
    'admin.crud.projectWebsite': 'URL du site',

    'admin.kpi.projects': 'Projets au total',
    'admin.kpi.users': 'Utilisateurs actifs',
    'admin.kpi.dataPoints': 'Points de données collectés',
    'admin.kpi.platforms': 'Plateformes en ligne',
    'admin.kpi.domains': 'Domaines de projets',
    'admin.kpi.activeProjects': 'Projets actifs',

    'admin.dashboard.domainsTitle': 'Vue d’ensemble des domaines',
    'admin.dashboard.manageDomains': 'Gérer les domaines',
    'admin.dashboard.projectsInDomain': 'Projets',
    'admin.dashboard.noDomains': 'Aucun domaine pour l’instant — créez-en un dans la gestion des domaines.',
    'admin.dashboard.seeAllProjects': 'Voir tous les projets →',
    'admin.dashboard.backendLive': 'Les indicateurs du tableau de bord proviennent de l’API (MongoDB).',
    'admin.dashboard.backendEmpty':
      'L’API répond mais la base ne contient pas encore d’enregistrements admin — affichage des données locales du navigateur jusqu’à synchronisation ou création côté MongoDB.',
    'admin.dashboard.backendError': 'Impossible de joindre l’API — affichage des données locales du navigateur.',
    'admin.dashboard.apiConnecting': 'Connexion à l’API…',

    'admin.recent.title': 'Projets récents',
    'admin.recent.col.project': 'Projet',
    'admin.recent.col.status': 'Statut',
    'admin.recent.status.active': 'Actif',
    'admin.recent.empty': 'Aucun projet pour l’instant — ajoutez-en depuis la gestion des projets.',

    'admin.activity.title': 'Activité en temps réel',
    'admin.activity.a1': 'Nouvelle inscription — partner@mmd-observatory.com',
    'admin.activity.a2': 'Import de données — Observatoire MoreMedDiet (2,4 Mo)',
    'admin.activity.a3': 'Alerte système — latence API MedAgriCycle rétablie',

    'admin.chart.title': 'Vue analytique',
    'admin.chart.subtitle': 'Croissance utilisateurs et usage des plateformes (30 derniers jours)',
    'admin.chart.placeholder': 'Zone graphique — branchez votre API analytique',
    'admin.consumption.title': 'Consommation par pays',
    'admin.consumption.subtitle': 'Usage des plateformes agrégé par pays (30 derniers jours)',
    'admin.consumption.total': 'Total :',
    'admin.consumption.unit': 'requêtes',
    'admin.consumption.backendLive': 'Données API (MongoDB)',
    'admin.consumption.backendError': 'API indisponible — données d’exemple affichées.',

    'admin.quick.title': 'Actions rapides',
    'admin.quick.newProject': 'Nouveau projet',
    'admin.quick.addUser': 'Ajouter un utilisateur',
    'admin.quick.report': 'Générer un rapport',
    'admin.quick.deploy': 'Déployer une mise à jour',

    'admin.module.projects.title': 'Gestion des projets',
    'admin.module.projects.lead':
      'Liste des projets avec statuts (Actif, En cours, Terminé) et suivi des lots de travaux. Branchez votre API pour des données en direct.',
    'admin.module.users.title': 'Gestion des utilisateurs',
    'admin.module.users.lead':
      'Rôles : Admin, Chercheur, Partenaire, Lecteur — avec permissions fines. Invitations et accès équipe.',
    'admin.module.data.title': 'Gestion des données',
    'admin.module.data.lead':
      'Import, validation et export (CSV / Excel). Pipelines et politiques de rétention configurables ici.',
    'admin.module.observatories.title': 'Observatoire de données',
    'admin.module.observatories.lead':
      'Tableaux temps réel, filtres et export. Lié aux observatoires PRIMA et projets de recherche.',
    'admin.module.blockchain.title': 'Tableau de bord blockchain',
    'admin.module.blockchain.lead':
      'Explorateur de traçabilité, journaux de transactions et statut des contrats (Techoney et chaînes associées).',
    'admin.module.analytics.title': 'Analytique & rapports',
    'admin.module.analytics.lead':
      'Graphiques avancés avec filtres par pays ou projet. Planification de rapports automatiques.',
    'admin.module.settings.title': 'Paramètres',
    'admin.module.settings.lead':
      'Profil organisation, clés API, intégrations et préférences (indicateurs staging / production).',

    'admin.settings.title': 'Paramètres',
    'admin.settings.saved': 'Paramètres enregistrés avec succès.',
    'admin.settings.smtpTitle': 'Configuration SMTP',
    'admin.settings.smtpHost': 'Hôte SMTP',
    'admin.settings.smtpPort': 'Port',
    'admin.settings.smtpSecure': 'Sécurisé (SSL)',
    'admin.settings.smtpUser': 'Utilisateur SMTP',
    'admin.settings.smtpPass': 'Mot de passe SMTP',
    'admin.settings.smtpFrom': "Adresse d'expédition",
    'admin.settings.contactTitle': 'Formulaire de contact',
    'admin.settings.contactToEmail': 'Adresse destinataire',
    'admin.settings.brandingTitle': 'Identité visuelle',
    'admin.settings.siteLogo': 'Logo du site',
    'admin.settings.siteFavicon': 'Favicon',
    'admin.settings.noLogo': 'Aucun logo téléversé',
    'admin.settings.noFavicon': 'Aucun favicon téléversé',
    'admin.settings.contactDetailsTitle': 'Coordonnées',
    'admin.settings.companyName': 'Nom de la société',
    'admin.settings.footerEmail': 'Email (pied de page)',
    'admin.settings.contactEmail': 'Email (page contact)',
    'admin.settings.contactPhone': 'Téléphone',
    'admin.settings.contactAddressLine1': 'Adresse (ligne 1)',
    'admin.settings.contactAddressLine2': 'Adresse (ligne 2)',
    'admin.settings.businessHours': 'Heures de travail',
    'admin.settings.mapEmbedUrl': 'URL de la carte',
    'admin.settings.socialTitle': 'Réseaux sociaux',
    'admin.settings.socialLinkedin': 'URL LinkedIn',
    'admin.settings.socialFacebook': 'URL Facebook',
    'admin.settings.socialTwitter': 'URL Twitter',
    'admin.settings.socialInstagram': 'URL Instagram',
    'admin.settings.socialWhatsapp': 'Numéro WhatsApp',
    'admin.settings.googleTitle': 'Google OAuth',
    'admin.settings.googleClientId': 'ID client Google',
    'admin.settings.googleClientSecret': 'Secret client Google',
    'admin.settings.googleRedirectUri': 'URI de redirection Google',
    'admin.settings.saving': 'Enregistrement...',
    'admin.settings.save': 'Enregistrer les paramètres',

    _navFromEn: {
      Login: 'Connexion',
      'Sign up': 'Inscription',
      Demos: 'Démos',
      Features: 'Fonctionnalités',
      Portfolio: 'Portfolio',
      Contact: 'Contact',
      Accueil: 'Accueil',
      Home: 'Accueil',
      Pricing: 'Tarifs',
      About: 'À propos',
      Blogs: 'Blog',
      'Help Center': "Centre d'aide",
      Careers: 'Carrières',
      Expertises: 'Expertises',
      Partenaires: 'Partenaires',
      Réalisations: 'Réalisations',
      Portfolio: 'Réalisations',
      'Qui sommes-nous': 'Qui sommes-nous',
      'Notre histoire': 'Notre histoire',
      'Pourquoi nous choisir': 'Pourquoi nous choisir',
      'Nous rejoindre': 'Pourquoi nous choisir',
      Solutions: 'Solutions',
      'Digital Twin': 'Jumeau numérique',
      Blockchain: 'Blockchain',
      'E-Living Lab': 'E-Living Lab',
    },
    _navFromFr: {
      Login: 'Connexion',
      Connexion: 'Connexion',
      Inscription: 'Inscription',
      'Sign up': 'Inscription',
      Demos: 'Démos',
      Démos: 'Démos',
      Features: 'Fonctionnalités',
      Fonctionnalités: 'Fonctionnalités',
      Portfolio: 'Portfolio',
      Contact: 'Contact',
      Accueil: 'Accueil',
      Home: 'Accueil',
      Tarifs: 'Tarifs',
      Pricing: 'Tarifs',
      'À propos': 'À propos',
      About: 'À propos',
      Blog: 'Blog',
      Blogs: 'Blog',
      "Centre d'aide": "Centre d'aide",
      'Help Center': "Centre d'aide",
      Carrières: 'Carrières',
      Careers: 'Carrières',
      Expertises: 'Expertises',
      Partenaires: 'Partenaires',
      Réalisations: 'Réalisations',
      Portfolio: 'Réalisations',
      'Qui sommes-nous': 'Qui sommes-nous',
      'Notre histoire': 'Notre histoire',
      'Pourquoi nous choisir': 'Pourquoi nous choisir',
      'Nous rejoindre': 'Pourquoi nous choisir',
      Solutions: 'Solutions',
      'Digital Twin': 'Jumeau numérique',
      Blockchain: 'Blockchain',
      'E-Living Lab': 'E-Living Lab',
    },
  },
};
